// EN/AR interface strings of the approved prototype (delta-prototype-v0.9, assets/i18n.js and assets/erp-i18n.js), copied
// verbatim so the approved wording is kept. Arabic follows the legacy audit dictionary. Production changes go in
// overrides.ts, never here, so this file can be diffed against the prototype.
export const PROTOTYPE_EN: Record<string, string> = {
 "brand": "Delta",
 "brandSub": "Accounting & ERP",
 "provisional": "Interim logo",
 "signInTitle": "Sign in to Delta",
 "signInLede": "Use your mobile number and password to open your company workspace.",
 "mobileNumber": "Mobile Number",
 "mobilePh": "05X XXX XXXX",
 "password": "Password",
 "passwordPh": "Enter your password",
 "rememberMe": "Remember me",
 "resetPassword": "Reset password",
 "forgetUid": "Forgot user ID",
 "signIn": "Sign In",
 "noAccount": "New to Delta?",
 "register": "Create an account",
 "officialSite": "Official website",
 "copyright": "© 2026 Delta. Prototype build.",
 "protoLogin": "Prototype: any values sign you in. Nothing is sent or stored.",
 "showPw": "Show password",
 "hidePw": "Hide password",
 "artTitle": "Sales, purchases, stock and the books, in one place.",
 "artBody": "Built for Saudi businesses that run several branches and warehouses, with tax invoices in Arabic and English.",
 "artSales": "Sales this month",
 "artCollected": "Collected",
 "artPoint1": "Sales, purchases and tax invoices",
 "artPoint2": "Multi-branch & multi-warehouse",
 "artPoint3": "Arabic and English",
 "search": "Search",
 "branch": "Branch",
 "allBranches": "All branches",
 "switchLang": "العربية",
 "notifications": "Notifications",
 "signOut": "Sign Out",
 "profile": "My profile",
 "orgSettings": "Organization settings",
 "planLabel": "Prototype",
 "planSub": "Synthetic demo data",
 "menu": "Menu",
 "collapse": "Collapse menu",
 "main": "Main",
 "operations": "Operations",
 "administration": "Administration",
 "home": "Home",
 "sales": "Sales",
 "purchases": "Purchases",
 "generalAccounts": "General Accounts",
 "items": "Items",
 "expenses": "Expenses",
 "reports": "Reports",
 "hr": "HR",
 "fixedAssets": "Fixed Assets",
 "warehouses": "Warehouses",
 "settings": "Settings",
 "pos": "POS",
 "salesInvoices": "Sales Invoices",
 "quotations": "Quotations",
 "salesRefunded": "Sales Refunded",
 "clients": "Clients",
 "collects": "Collects",
 "purchasesInvoices": "Purchases Invoices",
 "purchasesRefund": "Purchases Refund",
 "suppliers": "Suppliers",
 "payments": "Payments",
 "journalEntries": "Journal Entries",
 "cashTransfers": "Cash transfers",
 "deposit": "Deposit",
 "withdraw": "Withdraw",
 "partners": "Partners",
 "allItems": "All Items",
 "categories": "Categories",
 "unitConfig": "Unit Config",
 "barcodePrint": "Barcode Print",
 "itemKinds": "Item Kinds",
 "employees": "Employees",
 "allowances": "Allowances",
 "salaries": "Salaries",
 "loans": "Loans",
 "rewards": "Rewards",
 "deductions": "Deductions",
 "allAssets": "All Assets",
 "assetTypes": "Assets Types",
 "assetPurchases": "Assets Purchases",
 "assetDepreciation": "Assets Depreciation",
 "allWarehouses": "All Warehouses",
 "whInventory": "Warehouses Inventory",
 "beginningInventory": "Beginning Inventory",
 "corruptedInvoices": "Corrupted Invoices",
 "whTransfers": "Warehouses Transfers",
 "setOrg": "Organization",
 "setBranches": "Branches",
 "setTreasury": "Treasury",
 "accountsIndex": "Accounts Index",
 "indexesTypes": "Indexes Types",
 "costCenters": "Cost centers",
 "taxSettings": "Tax settings",
 "printers": "Printers",
 "users": "Users",
 "posSale": "Point of sale",
 "posInvoices": "POS invoices",
 "dashTitle": "Home",
 "dashGreeting": "Good evening, Sara",
 "dashSub": "Here is how {branch} is doing this month.",
 "newSalesInvoice": "New sales invoice",
 "purchaseInvoices": "Purchase Invoices",
 "invoicesWord": "invoices",
 "amount": "Amount",
 "vsLastMonth": "vs last month",
 "incomeVsExpenses": "Income vs expenses",
 "last6": "Last 6 months",
 "income": "Income",
 "topItems": "Top-selling items",
 "byRevenue": "By sales value, this month",
 "treasuries": "Treasuries",
 "treasuryBalances": "Current balances",
 "recentInvoices": "Recent sales invoices",
 "viewAll": "View all",
 "invoiceNo": "Invoice No",
 "account": "Account",
 "by": "By",
 "grandTotal": "Grand Total",
 "paid": "Paid",
 "remaining": "Remaining",
 "date": "Date",
 "status": "Status",
 "stPaid": "Paid",
 "stPartial": "Partially paid",
 "stUnpaid": "Unpaid",
 "quickActions": "Quick actions",
 "afterSignIn": "Open after sign in",
 "destDashboard": "Dashboard",
 "destPos": "POS",
 "qaPos": "Open POS sale screen",
 "openPos": "Open POS",
 "lineQtyWarn": "Quantity not available (stock {n})",
 "lineCostWarn": "Below unit cost",
 "qaCollect": "Record a collection",
 "qaPurchase": "New purchase invoice",
 "qaItem": "Add an item",
 "qaQuote": "New quotation",
 "cash": "Cash",
 "bank": "Bank",
 "chartTable": "Data table",
 "chartView": "Chart",
 "month": "Month",
 "createInvoice": "Create Invoice",
 "createSalesInvoice": "Create sales invoice",
 "draft": "Draft",
 "invoiceNumber": "Invoice no.",
 "invoiceDetails": "Invoice details",
 "invoiceDateTime": "Invoice date/time",
 "warehouse": "Warehouse",
 "customerName": "Customer Name",
 "selectCustomer": "Select a customer",
 "newCustomer": "New Customer",
 "paidReference": "Paid Reference",
 "note": "Note",
 "notePh": "Optional note printed on the invoice",
 "vatNo": "VAT No.",
 "balance": "Balance",
 "cashCustomer": "Cash customer",
 "invoiceLines": "Invoice lines",
 "searchBarcode": "Search with barcode",
 "barcodeHint": "Try 6281000000011 then press Enter",
 "add": "Add",
 "addLine": "Add line",
 "newItem": "New Item",
 "deleteSelected": "Delete",
 "itemName": "Item Name",
 "unitName": "Unit Name",
 "qty": "QTY",
 "price": "Price",
 "discountPct": "Disc. %",
 "discount": "Discount",
 "net": "Net",
 "tax": "Tax",
 "taxAmount": "Tax Amount",
 "total": "Total",
 "selectItem": "Select an item",
 "stock": "Stock",
 "pieces": "pcs",
 "sku": "SKU",
 "lines": "Lines",
 "selectAll": "Select all rows",
 "deleteRow": "Delete line",
 "noLines": "No lines yet. Add a line or scan a barcode.",
 "barcodeNotFound": "No item has barcode {x}.",
 "itemAdded": "{item} added.",
 "newItemToast": "In the full product this opens Items › Create item in a side panel.",
 "paymentTitle": "Discount & payment",
 "invoiceDiscountPct": "Invoice discount %",
 "invoiceDiscountAmt": "Discount (amount)",
 "treasury": "Treasury",
 "treasuryAmt": "Amount",
 "addTreasury": "Add treasury",
 "payInFull": "Pay in full",
 "payLater": "Pay later",
 "attachments": "Invoice Attachments",
 "dropFiles": "Drop files or click to browse",
 "dropHint": "PDF, JPG or PNG. Files stay in this browser; nothing is uploaded.",
 "removeFile": "Remove file",
 "summary": "Summary",
 "totalBeforeDiscount": "Total before discount",
 "subTotal": "Sub Total",
 "vat": "VAT",
 "assumptionTitle": "Prototype assumption:",
 "assumptionCalc": "Prices exclude VAT. Line discount, then invoice discount spread across lines by value, then VAT per line, rounded to 2 decimals. Confirm against the current system's server rules before build.",
 "printOptions": "Print options",
 "saveMode": "After saving",
 "without": "Without",
 "print": "Print",
 "thermalPrint": "Thermal print",
 "printLang": "Print language",
 "bilingual": "Arabic + English",
 "arabic": "Arabic",
 "english": "English",
 "copies": "Copies",
 "qrOnPrint": "ZATCA QR code on printout",
 "printAssume": "Print language and QR toggle are prototype assumptions; save mode and copies come from the audit.",
 "save": "Save",
 "saveAndPrint": "Save & print",
 "cancel": "Cancel",
 "preview": "Preview",
 "savedToast": "Prototype only: invoice {no} was not saved. Grand total {total}. {mode}",
 "modeWithout": "No printout.",
 "modePrint": "Would open the A4 tax invoice.",
 "modeThermal": "Would send to the thermal printer.",
 "needCustomer": "Select a customer before saving.",
 "needLines": "Add at least one line before saving.",
 "customerAdded": "{name} added to this session only.",
 "name": "Name",
 "mobile": "Mobile",
 "address": "Address",
 "vatNumber": "VAT number",
 "close": "Close",
 "sar": "SAR",
 "currency": "SAR",
 "notInProto": "Scheduled for a later batch",
 "notInProtoBody": "This audited screen keeps its place in the navigation and will be built in a later batch of this prototype.",
 "auditedPath": "Audited route",
 "backHome": "Back to Home",
 "openInvoice": "Open Create sales invoice",
 "demoBadge": "Demo",
 "demoTag": "Demo",
 "demoAbout": "Demo mode: synthetic data, simulated actions. Nothing is saved or sent.",
 "demoSimError": "Simulate a loading error on lists",
 "demoReset": "Reset demo data",
 "demoAssumptions": "Review notes and assumptions",
 "notInDemo": "Not available in this demo",
 "newInDelta": "New in Delta",
 "previewOnly": "Preview only",
 "notFound": "Record not found",
 "notFoundBody": "It may have been deleted in this demo session.",
 "all": "All",
 "choose": "Choose…",
 "view": "View",
 "edit": "Edit",
 "delete": "Delete",
 "ok": "OK",
 "yesSure": "Yes, sure",
 "no": "No",
 "yes": "Yes",
 "reset": "Reset",
 "retry": "Try again",
 "options": "Options",
 "customSearch": "Custom search",
 "searchWord": "Search word",
 "refreshResults": "Refresh results",
 "columns": "Columns",
 "density": "Density",
 "export": "Export",
 "exportCsv": "Export CSV (Excel)",
 "clearAll": "Clear all",
 "removeFilter": "Remove filter",
 "fromDate": "From date",
 "toDate": "To date",
 "dateTime": "Date & time",
 "type": "Type",
 "kind": "Kind",
 "showingOf": "Showing {a}–{b} of {n}",
 "rowsPerPage": "Rows per page",
 "prevPage": "Previous page",
 "nextPage": "Next page",
 "noResults": "No results",
 "noResultsBody": "No records match these filters. Change or clear them to see more.",
 "emptyTitle": "Nothing here yet",
 "emptyBody": "Records you add will appear in this list.",
 "loadErrorTitle": "Couldn't load the results",
 "loadErrorBody": "The server didn't respond. This is a simulated error from the Demo menu.",
 "requiredField": "Required field",
 "fixRequired": "Fill in the required fields marked in red.",
 "confirmDelete": "Are you sure to delete?",
 "deleteWarn": "Once it is deleted, it won't be restored.",
 "deletedToast": "{x} was deleted from this demo session.",
 "refreshedToast": "Results refreshed.",
 "csvToast": "CSV with {n} rows downloaded to this device.",
 "cantDelete": "This record can't be deleted",
 "filesStayLocal": "File names only; nothing is uploaded.",
 "reportDate": "Report date",
 "rowsCount": "{n} rows",
 "backToList": "Back to the list",
 "sampleQr": "Sample QR, not a valid ZATCA code",
 "printFooter": "Printed from the Delta demo. Not a valid tax document.",
 "receivedBy": "Received by",
 "approvedBy": "Approved by",
 "document": "Document",
 "statement": "Statement",
 "debit": "Debit",
 "credit": "Credit",
 "sub": "Sub-account",
 "simPosting": "Accounting entry (simulated)",
 "kpiNote": "Month to date ({month}), derived from the demo documents. Trends compare with the same days last month.",
 "noRecent": "No sales invoices for this branch yet.",
 "noTreasuryBranch": "No treasury is linked to this branch.",
 "beforeTax": "Before tax",
 "lineTotal": "Line total",
 "createQuotation": "Create quotation",
 "createPurchaseInvoice": "Create purchase invoice",
 "editSalesInvoice": "Edit sales invoice",
 "editQuotation": "Edit quotation",
 "editPurchaseInvoice": "Edit purchase invoice",
 "editInvoice": "Edit invoice",
 "editing": "Editing",
 "quotationNo": "Quotation no.",
 "newQuotation": "New quotation",
 "newPurchaseInvoice": "New purchase invoice",
 "saleInvoiceTitle": "Sales invoice",
 "quotationTitle": "Quotation",
 "saleRefundTitle": "Sales refund",
 "purchaseInvoiceTitle": "Purchase invoice",
 "purchaseRefundTitle": "Purchase refund",
 "supplierName": "Supplier Name",
 "selectSupplier": "Select a supplier",
 "newSupplier": "New Supplier",
 "needSupplier": "Select a supplier before saving.",
 "selectWarehouse": "You should select warehouse",
 "overPaid": "Treasury amounts are more than the grand total.",
 "quoteNoPay": "Quotations don't take payments. Treasury lines start when the quotation becomes a sales invoice.",
 "cantEdit": "This invoice can't be edited",
 "cantEditBody": "It already has a refund. Delete the refund first, or record the change as a new refund.",
 "showInvoice": "Show invoice",
 "invoiceData": "Invoice data",
 "invoiceItems": "Invoice items",
 "invoiceRefund": "Invoice refund",
 "originalInvoice": "Original invoice",
 "refund": "Refund",
 "refundedAmount": "Refunded",
 "refundTreasury": "Refund paid from",
 "noPayments": "No treasury payment. The full amount is on the account.",
 "relatedRefunds": "Related refunds",
 "noRefunds": "No refunds on this invoice.",
 "noAttachments": "No attachments.",
 "cantDeleteRefunds": "This invoice has refunds. Delete its refunds first.",
 "savedDocToast": "{no} saved in this demo session. Grand total {total}.",
 "updatedToast": "{no} updated in this demo session. Grand total {total}.",
 "branchFiltered": "Showing {b} only (top bar)",
 "noRefundsYet": "No refunds yet",
 "refundHow": "Refunds start from a sales invoice: open the invoice, then Options › Invoice refund.",
 "refundHowP": "Refunds start from a purchase invoice: open the invoice, then Options › Invoice refund.",
 "createRefund": "Create refund",
 "refundList": "Refund list",
 "addToRefund": "Add to refund",
 "added": "Added",
 "removeFromRefund": "Remove from refund",
 "fullyRefunded": "Fully refunded",
 "qtyToRefund": "Quantity to be refunded",
 "refundEmpty": "Add lines from the invoice items above.",
 "refundTotal": "Refund total",
 "refundNeedLines": "Add at least one line with a quantity to the refund list.",
 "selectTreasury": "Select a treasury.",
 "refundSaved": "Refund {no} saved in this demo session. Total {total}.",
 "taxInvoice": "Tax invoice",
 "simplifiedTaxInvoice": "Simplified tax invoice",
 "creditNote": "Credit note",
 "debitNote": "Debit note",
 "quotation": "Quotation",
 "purchaseInvoice": "Purchase invoice",
 "customer": "Customer",
 "supplier": "Supplier",
 "client": "Client",
 "newClient": "New Client",
 "editCustomer": "Edit client",
 "editSupplier": "Edit supplier",
 "maxWithdrawLimit": "Max withdraw limit",
 "openBalance": "Open balance",
 "taxNumber": "Tax Number",
 "commercialRecord": "Commercial record",
 "other": "Other",
 "pricing": "Pricing",
 "price_wholesale": "Wholesale",
 "price_half": "Half of wholesale",
 "price_retail": "Retail",
 "accountIndex": "Account Index",
 "openBalanceHint": "Changing it re-posts the opening entry in this demo.",
 "vatFormat": "Tax number must be 15 digits, starting and ending with 3.",
 "mobileFormat": "Mobile number must be 10 digits starting with 05.",
 "addedToast": "{x} added in this demo session.",
 "updatedPartyToast": "{x} updated in this demo session.",
 "cantDeleteParty": "It has invoices or vouchers. Records with transactions are kept for the books.",
 "balanceDue": "Balance due",
 "balanceOwed": "Balance owed",
 "totalInvoiced": "Total invoiced",
 "totalPurchased": "Total purchased",
 "netOfRefunds": "Net of refunds",
 "totalCollected": "Total collected",
 "totalPaid": "Total paid",
 "limitUsed": "{n} of the limit used",
 "noLimit": "No limit set",
 "accountStatement": "Account statement",
 "noInvoicesParty": "No invoices for this account.",
 "noMoneyParty": "No vouchers for this account.",
 "receiptId": "Receipt id",
 "receiptDetails": "Receipt details",
 "employee": "Employee",
 "partner": "Partner",
 "costCenter": "Cost center",
 "collectDateTime": "Collect date/time",
 "repaymentDateTime": "Repayment date/time",
 "newCollect": "New Collect",
 "editCollect": "Edit Collect",
 "newPayment": "New Payment",
 "editPayment": "Edit Payment",
 "newExpense": "New Expense",
 "editExpense": "Edit Expense",
 "newDeposit": "New Deposit",
 "editDeposit": "Edit deposit",
 "newWithdraw": "New Withdraw",
 "editWithdraw": "Edit withdraw",
 "newSalary": "New Salary",
 "newLoan": "New Loan",
 "newReward": "New Reward",
 "newDeduction": "New Deduction",
 "editReceipt": "Edit Receipt",
 "receiptVoucher": "Receipt voucher",
 "paymentVoucher": "Payment voucher",
 "expenseVoucher": "Expense voucher",
 "depositVoucher": "Deposit voucher",
 "withdrawVoucher": "Withdraw voucher",
 "salaryVoucher": "Salary voucher",
 "loanVoucher": "Loan voucher",
 "rewardVoucher": "Reward voucher",
 "deductionVoucher": "Deduction voucher",
 "salariesOne": "Salary",
 "loansOne": "Loan",
 "rewardsOne": "Reward",
 "deductionsOne": "Deduction",
 "amountPositive": "Enter an amount greater than zero for at least one treasury.",
 "treasuryRepeated": "Each treasury can appear only once.",
 "voucherSaved": "{no} saved in this demo session. Amount {total}.",
 "voucherUpdated": "{no} updated in this demo session.",
 "src_Sale": "Sales invoice",
 "src_SaleRefund": "Sales refund",
 "src_Purchase": "Purchase invoice",
 "src_PurchaseRefund": "Purchase refund",
 "src_Collect": "Collect",
 "src_Payment": "Payment",
 "src_Opening": "Opening balance",
 "src_Expense": "Expense",
 "src_Deposit": "Deposit",
 "src_Withdraw": "Withdraw",
 "src_Salary": "Salary",
 "src_Loan": "Loan",
 "src_Reward": "Reward",
 "src_Deduction": "Deduction",
 "src_CashTransfer": "Cash transfer",
 "src_Depreciation": "Depreciation",
 "src_AssetPurchase": "Asset purchase",
 "src_Journal": "Journal entry",
 "src_BeginningInventory": "Beginning inventory",
 "src_Corrupted": "Corrupted",
 "src_Transfer": "Warehouse transfer",
 "src_Inventory": "Inventory count",
 "src_Compromise": "Compromise",
 "journal": "Journal",
 "journalId": "Journal Id",
 "journalNo": "Journal No",
 "belongType": "Belong type",
 "newJournal": "New Journal",
 "editJournal": "Edit Journal",
 "viewJournal": "View Journal",
 "journalDateTime": "Journal date / time",
 "journalLines": "Journal lines",
 "journalAttachments": "Journal attachments",
 "journalLinesHint": "Each line is either a debit or a credit.",
 "statementPh": "What is this entry for?",
 "debitNotEqualCredit": "Debit not equal credit",
 "difference": "Difference",
 "journalNeedLines": "Add at least two lines with an account and an amount.",
 "journalLineInvalid": "Each line needs an account index and a debit or credit amount.",
 "manualJournals": "Manual",
 "autoJournals": "From documents",
 "autoJournal": "Created by a document",
 "autoJournalHint": "This entry was created by a document. To change it, edit or delete that document.",
 "autoJournalDelete": "This entry belongs to a document and is removed with it.",
 "openSource": "Open document",
 "selectRow": "Select row",
 "preparedBy": "Prepared by",
 "newTransfer": "New Transfer",
 "viewTransfer": "View transfer",
 "transferDetails": "Transfer details",
 "transferVoucher": "Cash transfer voucher",
 "fromTreasury": "From treasury",
 "toTreasury": "To treasury",
 "depositDate": "Deposit date",
 "depositNumber": "Deposit number",
 "deposite": "Deposit",
 "treasurySame": "Treasury cant be the same",
 "availableBalance": "Balance {x}",
 "transferSaved": "Transfer {no} saved ({total}). Simulated, nothing was sent.",
 "partnerName": "Partner name",
 "partnerTitle": "Title",
 "phone": "Phone",
 "newPartner": "New partner",
 "editPartner": "Edit partner",
 "editTransfer": "Edit Transfer",
 "balanced": "Balanced",
 "journalSaved": "Journal entry saved ({total}). Simulated, nothing was sent.",
 "journalUpdated": "Journal entry updated ({total}). Simulated.",
 "itemData": "Item data",
 "itemSettings": "Kind, tax and display",
 "createItem": "Create Item",
 "editItem": "Edit Item",
 "saveItem": "Save Item",
 "itemCode": "Item Code",
 "category": "Category",
 "categoryName": "Category Name",
 "categoryTitleAr": "Category Title in arabic",
 "categoryTitleEn": "Category Title in english",
 "nameAr": "Name in arabic",
 "nameEn": "Name in english",
 "descriptionAr": "Description in arabic",
 "descriptionEn": "Description in english",
 "minQty": "Min QTY",
 "itemImage": "Item Image",
 "chooseImage": "Choose an image (stays in this browser)",
 "remove": "Remove",
 "itemKind": "Item kind",
 "taxType": "Tax type",
 "priceIncludeTax": "Price include tax",
 "quickList": "Quick list",
 "quickListPos": "Show in the POS quick list",
 "units": "Units",
 "unit": "Unit",
 "piecesNo": "Pieces No",
 "unitBarcode": "Unit Barcode",
 "unitBarcodes": "Unit barcodes",
 "barcode": "Barcode",
 "barcodes": "Barcodes",
 "unitsHint": "The first row is the base unit (1 piece). Other units hold several pieces.",
 "baseUnitHint": "The base unit is always 1 piece",
 "addBarcodePh": "Type a barcode, press Enter",
 "autoGenerate": "Auto generate",
 "deleteBarcode": "Delete barcode",
 "barcodeTaken": "Barcode {x} is already used by another unit.",
 "codeTaken": "This item code is already used.",
 "unitRowInvalid": "Unit row {n}: pieces must be 1 or more and a retail price is required.",
 "unitDuplicate": "The same unit and pieces appear twice.",
 "itemSaved": "{x} was added in this demo session.",
 "itemUpdated": "{x} was updated in this demo session.",
 "hasNoStock": "Has no stock",
 "noStockKind": "No stock",
 "hasQty": "Has QTY (track stock)",
 "lowStock": "Low stock",
 "stockByWarehouse": "Stock by warehouse",
 "recentMovements": "Recent movements",
 "noMovements": "No movements yet.",
 "barcodeHintItems": "Scan or type a unit barcode and press Enter to open the item.",
 "cantDeleteItem": "This item is used on invoices and cannot be deleted.",
 "newCategory": "New category",
 "editCategory": "Edit category",
 "newUnit": "New Unit",
 "editUnit": "Edit Unit",
 "itemsCount": "Items",
 "nameTaken": "This name already exists.",
 "cantDeleteCategory": "Items use this category.",
 "cantDeleteUnit": "Items use this unit.",
 "newItemKind": "New item kind",
 "editItemKind": "Edit item kind",
 "salesAccount": "Sales account",
 "salesRefundAccount": "Sales refund account",
 "salesCostAccount": "Sales cost account",
 "inventoryAccount": "Inventory account",
 "corruptedAccount": "Corrupted account",
 "discountAccount": "Discount account",
 "cantDeleteKind": "Items use this kind.",
 "kindQtyLocked": "Items of this kind are already on invoices, so stock tracking cannot be switched.",
 "copiesNo": "Copies No",
 "noBarcode": "No barcode",
 "selectedN": "{n} selected",
 "selectToPrint": "Select at least one unit with a barcode.",
 "labelHint": "Sample label layout. Label size and content come from the branch barcode settings in the real system.",
 "cantDeletePartner": "This partner is used on vouchers or journal entries.",
 "newWarehouse": "New Warehouse",
 "editWarehouse": "Edit warehouse",
 "warehouseName": "Warehouse",
 "cantDeleteWarehouse": "Stock documents use this warehouse, so it cannot be deleted.",
 "whAccountTaken": "Another warehouse already uses this account index.",
 "stockValue": "Stock value",
 "itemsInStock": "Items in stock",
 "viewStock": "View stock",
 "newBeginningHere": "New beginning inventory",
 "newCountHere": "New inventory",
 "averagePrice": "Average price",
 "actualQty": "Actual qty",
 "systemQtyHint": "QTY is the system quantity in this warehouse when the line was added.",
 "kindInventory": "Inventory",
 "kindCompromise": "Compromise",
 "kindBeginning": "Beginning inventory",
 "kindCorrupted": "Corrupted",
 "kindTransfer": "Transfer",
 "invCompTitle": "Inventory & Compromise",
 "newInvoice": "New Invoice",
 "newInventory": "New Inventory",
 "invoiceType": "Invoice type",
 "biTitle": "Beginning inventory",
 "crTitle": "Corrupted invoice",
 "trTitle": "Warehouse transfer",
 "ivTitle": "Inventory",
 "cpTitle": "Compromise",
 "fromWarehouse": "From warehouse",
 "toWarehouse": "To Warehouse",
 "selectWarehouseFirst": "You should select warehouse first",
 "noInventoryChanges": "There is no changes in inventory",
 "changeWhTitle": "Change warehouse?",
 "changeWhLoses": "Changing warehouse causes losing all items.",
 "changeWh": "Change warehouse",
 "sameWarehouse": "The source and destination warehouses can't be the same.",
 "stockNeedLines": "Add at least one item.",
 "stockLineInvalid": "Each line needs an item, a unit and a quantity greater than zero.",
 "countLineInvalid": "Each line needs an item, a unit and an actual quantity of zero or more.",
 "availableN": "Available {n}",
 "exceedsStock": "More than the available stock",
 "exceedsTitle": "Save with negative stock?",
 "exceedsBody": "{n} line(s) take more than the available stock, so the warehouse balance will go negative.",
 "saveAnyway": "Save anyway",
 "loadAllItems": "Load all items in stock",
 "loadedN": "{n} items loaded",
 "alreadyListed": "{x} is already in the list.",
 "stockDocSaved": "{no} saved · {total}",
 "stockDocUpdated": "{no} updated · {total}",
 "diffValue": "Difference value",
 "countedValue": "Counted value",
 "linesCount": "Lines",
 "stockLinesHint": "Scan a barcode or add a line, then choose the item and unit.",
 "noStockRows": "No stock yet",
 "noStockBody": "Stock appears here after beginning inventory, purchases or transfers.",
 "stockOnHand": "Stock",
 "stockPrintTitle": "Stock",
 "belowMin": "Below minimum",
 "baseUnitNote": "Quantities are in each item's base unit.",
 "stockDocEmpty": "No documents yet",
 "stockDocEmptyBody": "Create the first one with New Invoice.",
 "whEmpty": "No warehouses yet",
 "whEmptyBody": "Add a warehouse for each place you keep stock.",
 "emailFormat": "Enter a valid email address.",
 "employeeName": "Employee name",
 "nationality": "Nationality",
 "role": "Role",
 "job": "Job",
 "city": "City",
 "neighborhood": "Neighborhood",
 "emailF": "Email",
 "citizenF": "Citizen",
 "foreigner": "Foreigner",
 "citizenship": "Citizenship",
 "nationalId": "National ID",
 "renewalDate": "Renewal Date",
 "passportNo": "Passport No",
 "expiryDate": "Expiry Date",
 "basicSalary": "Basic salary",
 "incentive": "Incentive",
 "totalSalary": "Total salary",
 "bankName": "Bank name",
 "ibanF": "IBAN",
 "accountNo": "Account no",
 "transferMethod": "Transfer method",
 "tmBank": "Bank transfer",
 "tmCash": "Cash",
 "residence": "Residence (iqama)",
 "residenceAmount": "Residence amount",
 "residenceRenewal": "Residence renewal",
 "residenceExpiry": "Residence expiry",
 "residenceTotal": "Residence total cost",
 "medicalInsurance": "Medical insurance",
 "socialInsurance": "Social insurance",
 "healthCert": "Health certificate",
 "healthExpiry": "Health certificate expiry",
 "annualLeave": "Annual leave (days)",
 "annualPaid": "Annual leave paid",
 "ticket": "Travel ticket",
 "casualLeave": "Casual leave (days)",
 "sickLeave": "Sick leave (days)",
 "personalData": "Personal data",
 "financialData": "Financial data",
 "vacations": "Vacations",
 "empAttachments": "Attachments",
 "nextStep": "Next",
 "prevStep": "Back",
 "stepOf": "Step {a} of {b}",
 "newEmployee": "New Employee",
 "addEmployee": "Add Employee",
 "editEmployee": "Edit Employee",
 "showEmployee": "Show Employee",
 "uploadIdentity": "You should upload identity",
 "identityHint": "Identity image (required) and any other documents. Files stay in this browser.",
 "employeeSaved": "{x} saved",
 "cantDeleteEmployee": "This employee has vouchers and cannot be deleted.",
 "empVouchers": "Vouchers",
 "noVouchers": "No vouchers yet",
 "paidThisYear": "Paid in 2026",
 "loanBalance": "Loans less deductions",
 "newAllowance": "New Allowance",
 "editAllowance": "Edit allowance",
 "cantDeleteAllowance": "Employees receive this allowance.",
 "employeesCount": "Employees",
 "salaryGroup": "Salary Group",
 "searchByStore": "Search by store",
 "selectBranchFirst": "Choose a branch to list its employees.",
 "selectTreasuryEach": "You should select journal for each group",
 "totalEqualTreasury": "Total should equal treasury amount",
 "paidThisMonth": "Already paid this month",
 "salaryRunSaved": "{n} salary vouchers created · {total}",
 "noEmpSelected": "Select at least one employee.",
 "payTo": "Pay",
 "salaryRunHint": "Each selected employee gets one salary voucher for their total salary from the chosen treasury.",
 "monthsWhole": "Enter a whole number of months.",
 "depSameAccount": "The asset account and the depreciation account must differ.",
 "monthShort": "mo",
 "assetName": "Asset name",
 "fixedAssetAmount": "Fixed asset amount",
 "depreciationMonthly": "Depreciation monthly",
 "fixedAssetKind": "Fixed asset kind",
 "startWorkDate": "Start work date",
 "calcMonthly": "Calculate monthly depreciation",
 "newFixedAsset": "New Fixed Asset",
 "editFixedAsset": "Edit fixed asset",
 "kindName": "Kind Name",
 "depPeriod": "Deperciation Period (months)",
 "depAccount": "Deperciation Account",
 "depExpAccount": "Depreciation Expense Account",
 "newAssetKind": "New Fixed Asset kind",
 "editAssetKind": "Edit asset kind",
 "cantDeleteAssetKind": "Assets use this kind.",
 "assetDeportedLock": "Once it deported, asset cant be edited",
 "undeportWarn": "Once it undeported, you cant restore journal entry",
 "deport": "Deport",
 "undeport": "Undeport",
 "isDeported": "Is deported",
 "deportTitle": "Deport depreciation?",
 "deportBody": "This posts {amt} to the depreciation accounts.",
 "deportedToast": "{x} deported",
 "undeportedToast": "{x} undeported",
 "deportUpTo": "Deport due periods",
 "deportDueBody": "{n} periods up to {d} will be posted ({amt}).",
 "nothingDue": "No periods are due.",
 "assetTitle": "Asset title",
 "fromF": "From",
 "toF": "To",
 "endDate": "End date",
 "deportedYes": "Deported",
 "deportedNo": "Not deported",
 "bookValue": "Book value",
 "accumulatedDep": "Accumulated depreciation",
 "scheduleRows": "Schedule",
 "noDepreciation": "No monthly depreciation",
 "createAssetsPurchase": "Create Assets Purchase",
 "assetInvoice": "Asset purchase invoice",
 "paidTotal": "Paid Total",
 "paidAmount": "Paid amount",
 "chooseKindTax": "Choose asset kind and tax type for each item",
 "assetLineInvalid": "Each line needs a statement, a quantity and a price.",
 "paidOverGrand": "Paid amount can't exceed the grand total.",
 "assetsCreated": "{no} saved · {n} assets added",
 "cantDeleteAssetInvoice": "Depreciation of its assets is deported.",
 "assetFromInvoice": "From invoice",
 "linkedAssets": "Assets from this invoice",
 "myAccount": "My account",
 "unsavedChanges": "Unsaved changes",
 "allSaved": "All changes saved",
 "discardChanges": "Discard changes",
 "settingsOrg": "Settings Organizations",
 "orgData": "Organization data",
 "orgDataHint": "Printed on invoices, vouchers and reports.",
 "logo": "Logo",
 "logoHint": "PNG or JPG. It stays in this browser.",
 "removeLogo": "Remove logo",
 "logoType": "Choose an image file.",
 "vatHint": "15 digits, starts and ends with 3.",
 "contactInfo": "Contact",
 "landline": "Landline",
 "fax": "Fax",
 "addressF": "Address",
 "country": "Country",
 "region": "Region",
 "street": "Street",
 "controlAccounts": "Default accounts",
 "controlAccountsHint": "Client and supplier balances post to these chart of accounts entries.",
 "customerAccount": "Customer chart of account",
 "supplierAccount": "Supplier chart of account",
 "sameControlAccount": "Customers and suppliers need different accounts.",
 "controlAccountsChange": "Change default accounts?",
 "controlAccountsBody": "In this demo, all client and supplier balances move to the new accounts. How the current system treats existing postings is not verified.",
 "orgSaved": "Organization settings saved in this demo session.",
 "settingsBranches": "Settings Branches",
 "newStore": "New Store",
 "newBranch": "New Branch",
 "editBranch": "Edit branch",
 "addressAr": "Address in arabic",
 "addressEn": "Address in english",
 "monthlyExpense": "Monthly Expense",
 "currencyF": "Currency",
 "phoneFormat": "Phone must start with 0 and have 9 or 10 digits.",
 "barcodeSettings": "Barcode settings",
 "branchInUse": "This branch has warehouses, treasuries, users, employees or documents.",
 "barcodeGeneral": "Barcode general fields",
 "barcodeWeight": "Barcode weight fields",
 "sizeF": "Size",
 "heightF": "Height",
 "widthF": "Width",
 "marginTop": "Margin top",
 "marginBottom": "Margin bottom",
 "marginRight": "Margin right",
 "marginLeft": "Margin left",
 "labelShows": "Show on label",
 "showTitle": "Show title",
 "showText": "Show text",
 "showName": "Show name",
 "showPrice": "Show price",
 "weightActive": "Weight active",
 "weightLeftFlag": "Weight left flag",
 "weightCodeLen": "Weight code length",
 "weightQtyLen": "Weight Qty length",
 "weightCheckLen": "Weight check length",
 "weightOffHint": "Turn on to read item code and weight from scale labels.",
 "labelPreview": "Label preview",
 "labelPreviewHint": "Approximate preview with a sample item. Sizes are in millimetres.",
 "weightSample": "Sample scale barcode",
 "weightNot13": "These lengths add up to {n} digits. EAN-13 scale labels use 13.",
 "weight13ok": "13 digits, matches EAN-13.",
 "positiveNumber": "Enter a number greater than zero.",
 "zeroOrMore": "Enter zero or more.",
 "wholeNumber": "Enter a whole number.",
 "barcodeSaved": "Barcode settings for {x} saved in this demo session.",
 "settingsTreasury": "Settings Treasury",
 "treasuryName": "Treasury name",
 "newTreasury": "New Treasury",
 "bankDetails": "Bank details",
 "accountNumber": "Account number",
 "commissionPct": "Commission %",
 "commissionAccount": "Commission account",
 "commissionTaxType": "Commission tax type",
 "commissionAccountReq": "Choose a commission account when the commission is above zero.",
 "accountTaken": "This account is already linked to another treasury or warehouse.",
 "treasuryAccountLocked": "This treasury has postings, so its account can't change.",
 "ibanFormat": "IBAN must be SA followed by 22 digits.",
 "percentRange": "Percentage must be between 0 and 100.",
 "treasuryInUse": "This treasury has vouchers, payments or postings.",
 "drShort": "Dr",
 "crShort": "Cr",
 "accountHasPostings": "This account has postings.",
 "accountLinked": "This account is linked in settings (treasury, warehouse, item kind, tax, asset kind or default accounts).",
 "indexCode": "Index code",
 "codeHint": "Starts with the main index code.",
 "mainIndex": "Main Index",
 "codeDigits": "The code must be digits only.",
 "codePrefix": "The code must start with {p} and be longer than it.",
 "accCodeTaken": "This code already exists.",
 "accountMoveLocked": "An account with postings can't move to another level-1 group.",
 "newAccountIndex": "New Account Index",
 "editAccountIndex": "Edit Account Index",
 "newIndex": "New Index",
 "newIndexType": "New Index Type",
 "editIndexType": "Edit Index Type",
 "typeL1Locked": "It has accounts, so its level 1 group can't change.",
 "typeCodeFull": "This level 1 group already has 9 types.",
 "accountsCount": "Accounts",
 "level1Fixed": "Level 1 is fixed: Assets, Liabilities, Owner's equity, Expenses, Revenues.",
 "typeHasAccounts": "This type has accounts.",
 "chartTree": "Chart of accounts tree",
 "chartOfAccounts": "Chart of accounts",
 "noAccountsYet": "No accounts yet",
 "searchAccount": "Search code or name",
 "expandAll": "Expand all",
 "collapseAll": "Collapse all",
 "treeBalanceHint": "Balances are new in Delta, computed from the demo postings.",
 "postingsCount": "Postings",
 "description": "Description",
 "accountData": "Account data",
 "movements": "Movements",
 "lastN": "Latest {n}",
 "costCentersSettings": "Cost centers settings",
 "newCostCenter": "New cost center",
 "editCostCenter": "Edit cost center",
 "noCostCenters": "No cost centers yet",
 "noCostCentersBody": "Add one to tag journal entry lines.",
 "costCenterInUse": "Journal entry lines use this cost center.",
 "percentage": "Percentage",
 "newTax": "New tax",
 "editTax": "Edit tax",
 "taxRateLocked": "Documents use this tax, so its percentage can't change.",
 "taxInUse": "Items, documents or treasuries use this tax.",
 "printersSetting": "Printers setting",
 "newPrinter": "New printer",
 "editPrinter": "Edit printer",
 "port": "Port",
 "hardMarginX": "Hard margin X",
 "hardMarginY": "Hard margin Y",
 "paperWidth": "Paper width",
 "paperWidthHint": "In millimetres, usually 58 or 80.",
 "ipFormat": "Enter an IPv4 address such as 192.168.1.50.",
 "portFormat": "Port must be a number from 1 to 65535.",
 "testPrint": "Test print",
 "testPrintSim": "Prototype only: a test page for {x} ({ip}) was not sent.",
 "printerInUse": "{n} users print to this printer.",
 "newUser": "New user",
 "editUser": "Edit user",
 "enterPhone": "Enter phone number",
 "passwordKeep": "Leave empty to keep the current password.",
 "passwordRule": "At least 6 characters.",
 "allowedTreasuries": "Treasuries this user may use.",
 "allowedWarehouses": "Warehouses this user may use.",
 "ticketPrinter": "Ticket printer",
 "ticketCopies": "Ticket copies",
 "ticketPrinting": "Ticket printing",
 "activeF": "Active",
 "inactive": "Inactive",
 "adminSeesAll": "Administrators see everything; their permissions can't be limited.",
 "phoneTaken": "Another user has this phone number.",
 "printerRequired": "Choose a ticket printer when printing is on.",
 "copiesRange": "Copies must be from 1 to 5.",
 "userLimit": "Your plan allows {n} active users. Upgrade the plan or add users from the cart.",
 "userAdded": "{x} added with user ID {id}. Only the Home permission is on.",
 "userPasswordSet": "{x} updated. The new password was not stored anywhere in this demo.",
 "you": "You",
 "userId": "User id",
 "administrator": "Administrator",
 "userKind": "User",
 "copiesNumber": "Copies number",
 "seatsUsed": "{a} of {b} active users on your plan",
 "addUsers": "Add users",
 "editPermission": "Edit permission",
 "cantDeleteSelf": "You can't delete the user you are signed in with.",
 "cantDeleteAdmin": "Administrator accounts can't be deleted here.",
 "cantLockSelf": "You can't remove your own access to Users.",
 "permsSaved": "Permissions for {x} saved in this demo session ({n} changed).",
 "allOn": "All on",
 "feature": "Feature",
 "updateF": "Update",
 "otherPerms": "Other",
 "permHint": "Turning on Add, Update or Delete also turns on View.",
 "tabAllOn": "Turn on whole tab",
 "tabAllOff": "Turn off whole tab",
 "user": "User",
 "permsOn": "Permissions on",
 "savePerms": "Save permissions",
 "tabInvoices": "Invoices",
 "tabWarehouses": "Warehouses",
 "tabGeneralAccounts": "General Accounts",
 "tabFixedAssets": "Fixed Assets",
 "tabHr": "Hr",
 "tabSettings": "Settings",
 "tabReports": "Reports",
 "repAccounting": "Accounting reports",
 "repFinancial": "Financial reports",
 "repInvoices": "Invoices reports",
 "repEmployees": "Employees Reports",
 "repParties": "Clients and suppliers reports",
 "repTreasury": "Treasury reports",
 "repTaxes": "Taxes Reports",
 "repWarehouses": "Warehouses Reports",
 "repAssets": "Assets reports",
 "clientArea": "Client Area",
 "accountInfo": "Account Info",
 "subscriptions": "Subscriptions",
 "billingInvoices": "Invoices",
 "orgName": "Organization name",
 "activity": "Activity",
 "caInfoHint": "To change these details, edit",
 "currentPlan": "Current plan",
 "expired": "Expired",
 "billingCycle": "Billing cycle",
 "yearly": "Yearly",
 "monthlyF": "Monthly",
 "daysLeft": "{n} days left",
 "renewPlan": "Renew",
 "changePlan": "Change plan",
 "subscriptionNo": "Subscription No",
 "plan": "Plan",
 "periodF": "Period",
 "additionalUsers": "Additional users",
 "additionalWarehouses": "Additional warehouses",
 "startDate": "Start date",
 "renewalPrice": "Renewal price",
 "paymentMethod": "Payment method",
 "onlinePayment": "Online payment",
 "bankTransfer": "Bank transfer",
 "amountInclVat": "Amount incl. VAT",
 "underReview": "Under review",
 "unpaid": "Unpaid",
 "payNow": "Pay now",
 "noBills": "No billing invoices yet",
 "billPrintSim": "Prototype only: {no} was not printed.",
 "renewSoon": "Your subscription ends in {n} days.",
 "mod_pos": "Point of sale",
 "mod_accounting": "Accounting",
 "mod_hr": "HR",
 "mod_asset": "Fixed assets",
 "mod_linking": "Linking with other software",
 "payment": "Payment",
 "paymentSimHint": "Simulated. No card details are asked for and nothing is charged.",
 "transferHint": "Upload the bank transfer receipt. It stays in this browser and the bill waits for review.",
 "cardHint": "The live system opens the URWAY payment page here. This demo skips it.",
 "transferReceipt": "Transfer receipt",
 "paymentConfirming": "Payment is being confirmed…",
 "paymentOk": "Payment successful (simulated): {a}.",
 "transferUploaded": "Transfer receipt for {a} attached. The bill is under review (simulated).",
 "planTooSmall": "This plan is too small",
 "planTooSmallBody": "Add at least {u} users and {w} warehouses, or choose a bigger plan.",
 "yearShort": "year",
 "planIncludes": "{u} users · {w} warehouses",
 "choosePlan": "Choose plan",
 "planOptions": "Period and add-ons",
 "yearlySaves": "Yearly is priced as 10 months.",
 "planInfo": "Plan info",
 "planPrice": "Plan price",
 "additionalUsersCost": "Additional users cost",
 "additionalWarehousesCost": "Additional warehouses cost",
 "vat15": "VAT 15%",
 "planPriceTotal": "Plan price total",
 "generalLedger": "General Ledger",
 "trialTotals": "Trial balance with totals and balances",
 "trialBalances": "Trial balance with balances",
 "chartStatement": "Chart of account statement",
 "receiptPayment": "Receipts and payments report",
 "incomeStatement": "Income statement",
 "balanceSheet": "Balance Sheet",
 "invoicesDetails": "Invoices Details",
 "invoicesProfits": "Invoices profits",
 "employeeStatement": "Employee statement",
 "employeesSalaries": "Employees salaries",
 "partiesReport": "Clients and suppliers report",
 "treasuryReport": "Treasury report",
 "treasuryStatement": "Treasury statement",
 "movementSummary": "Movement summary",
 "salesTax": "Sales tax",
 "purchaseTax": "Purchase tax",
 "assetTax": "Asset tax report",
 "taxReturn": "Tax return",
 "assetsReport": "Assets report",
 "assetDepReport": "Assets depreciation report",
 "assetInvoicesR": "Asset invoices",
 "assetInvoiceDetails": "Assets invoice details",
 "warehousesReport": "Warehouses report",
 "movement": "Movement",
 "netMovement": "Net movement",
 "endBalance": "End balance",
 "percentagePct": "Percentage (%)",
 "cost": "Cost",
 "profit": "Profit",
 "salary": "Salary",
 "rpIn": "Income",
 "rpOut": "Outcome",
 "drS": "Dr",
 "crS": "Cr",
 "depreciationDate": "Depreciation date",
 "excelExport": "Excel export",
 "chooseDots": "Choose…",
 "netProfit": "Net profit (loss)",
 "periodProfit": "Profit for the period (calculated)",
 "totalAssets": "Total assets",
 "totalLiabEq": "Total liabilities and equity",
 "notBalanced": "Not balanced",
 "bsBalanced": "Assets equal liabilities plus equity for this period.",
 "bsNotBalanced": "Assets don't equal liabilities plus equity. Check the postings.",
 "taxDue": "Tax due",
 "totalRevenues": "Total revenues",
 "totalExpenses": "Total expenses",
 "taxRefundable": "Tax refundable",
 "pr_today": "Today",
 "pr_yesterday": "Yesterday",
 "pr_thisWeek": "This week",
 "pr_lastWeek": "Last week",
 "pr_thisMonth": "This month",
 "pr_lastMonth": "Last month",
 "pr_thisYear": "This year",
 "pr_lastYear": "Last year",
 "prQ": "Quarter {n}",
 "pr_all": "All dates",
 "pr_custom": "Custom range",
 "rpFiltersChanged": "Filters changed. Press Search to update the results.",
 "rpChoose": "Choose {x}, then press Search.",
 "rpResults": "Results",
 "rpHubSearch": "Find a report",
 "rpHubSub": "{n} report links in {g} groups. Every report reads the same synthetic ledger as the other screens.",
 "rpNoMatch": "No report matches your search",
 "rpMenuOnly": "Menu only in the current system",
 "rpMovedNote": "The current system lists this report only in the side menu; the new Delta also shows it on the hub.",
 "rpSearchWordPh": "Name, SKU or barcode",
 "rpXlsToast": "{n} rows exported to {f}. The file is built in this browser.",
 "planIncludesLong": "{u} users and {w} warehouses, billed {p}.",
 "next": "Next",
 "cartSimHint": "Prices are synthetic.",
 "planCart": "Plan cart",
 "accessDenied": "Access denied",
 "accessDeniedTitle": "You don't have permission to open this page",
 "accessDeniedBody": "The demo user {u} is missing the permission below.",
 "accessDeniedHint": "An administrator can grant it in Settings › Users › Edit permission. In this prototype the check runs in the browser only; the production system must enforce it on the server.",
 "switchDemoUser": "Switch demo user",
 "roleAdmin": "Administrator",
 "roleRestricted": "Restricted user",
 "switchedTo": "Now signed in as {x}.",
 "noPermission": "No permission",
 "noPermissionFor": "No permission: {p}",
 "anyReport": "Any report",
 "demoUserNow": "Demo user scope",
 "scopeAll": "All branches, warehouses and treasuries",
 "scopeOf": "Branch: {b} · Warehouses: {w} · Treasuries: {tr}",
 "scopeDenied": "This user can't use that warehouse or treasury.",
 "noTreasuryScope": "This user has no treasury assigned."
};

export const PROTOTYPE_AR: Record<string, string> = {
 "brand": "دلتا",
 "brandSub": "المحاسبة وتخطيط الموارد",
 "provisional": "شعار مؤقت",
 "signInTitle": "تسجيل الدخول إلى دلتا",
 "signInLede": "استخدم رقم الجوال وكلمة المرور للدخول إلى مساحة عمل شركتك.",
 "mobileNumber": "رقم الجوال",
 "mobilePh": "05X XXX XXXX",
 "password": "كلمة المرور",
 "passwordPh": "أدخل كلمة المرور",
 "rememberMe": "تذكرني",
 "resetPassword": "استعادة كلمة المرور",
 "forgetUid": "نسيت معرّف المستخدم",
 "signIn": "تسجيل الدخول",
 "noAccount": "جديد على دلتا؟",
 "register": "تسجيل حساب جديد",
 "officialSite": "الموقع الرسمي",
 "copyright": "© 2026 دلتا. نسخة تجريبية.",
 "protoLogin": "نموذج أولي: أي قيم تدخلك. لا يتم إرسال أو حفظ أي بيانات.",
 "showPw": "إظهار كلمة المرور",
 "hidePw": "إخفاء كلمة المرور",
 "artTitle": "المبيعات والمشتريات والمخزون والحسابات في مكان واحد.",
 "artBody": "مصمم للمنشآت السعودية متعددة الفروع والمخازن، مع فواتير ضريبية بالعربية والإنجليزية.",
 "artSales": "مبيعات هذا الشهر",
 "artCollected": "المحصّل",
 "artPoint1": "المبيعات والمشتريات والفواتير الضريبية",
 "artPoint2": "فروع ومخازن متعددة",
 "artPoint3": "العربية والإنجليزية",
 "search": "بحث",
 "branch": "الفرع",
 "allBranches": "جميع الفروع",
 "switchLang": "English",
 "notifications": "الإشعارات",
 "signOut": "تسجيل الخروج",
 "profile": "ملفي الشخصي",
 "orgSettings": "إعدادات الشركة",
 "planLabel": "نموذج أولي",
 "planSub": "بيانات تجريبية",
 "menu": "القائمة",
 "collapse": "طي القائمة",
 "main": "الرئيسية",
 "operations": "العمليات",
 "administration": "الإدارة",
 "home": "الرئيسية",
 "sales": "المبيعات",
 "purchases": "المشتريات",
 "generalAccounts": "الحسابات العامة",
 "items": "الأصناف",
 "expenses": "المصروفات",
 "reports": "التقارير",
 "hr": "الموارد البشرية",
 "fixedAssets": "الأصول الثابتة",
 "warehouses": "المخازن",
 "settings": "الإعدادات",
 "pos": "نقطة البيع",
 "salesInvoices": "فواتير المبيعات",
 "quotations": "عروض السعر",
 "salesRefunded": "مرتجعات المبيعات",
 "clients": "العملاء",
 "collects": "التحصيل",
 "purchasesInvoices": "فواتير المشتريات",
 "purchasesRefund": "مرتجعات المشتريات",
 "suppliers": "الموردين",
 "payments": "السداد",
 "journalEntries": "قيود اليومية",
 "cashTransfers": "التحويلات النقدية",
 "deposit": "سندات الإيداع",
 "withdraw": "سندات السحب",
 "partners": "الشركاء",
 "allItems": "جميع الأصناف",
 "categories": "التصنيفات",
 "unitConfig": "إعداد الوحدات",
 "barcodePrint": "طباعة الباركود",
 "itemKinds": "أنواع الأصناف",
 "employees": "الموظفين",
 "allowances": "البدلات",
 "salaries": "الرواتب",
 "loans": "السلف",
 "rewards": "المكافآت",
 "deductions": "الخصومات",
 "allAssets": "جميع الأصول",
 "assetTypes": "أنواع الأصول",
 "assetPurchases": "مشتريات الأصول",
 "assetDepreciation": "إهلاك الأصول",
 "allWarehouses": "جميع المخازن",
 "whInventory": "جرد المخازن",
 "beginningInventory": "مخزون أول المدة",
 "corruptedInvoices": "فواتير الهالك",
 "whTransfers": "تحويلات المخازن",
 "setOrg": "إعدادات الشركة",
 "setBranches": "إعدادات الفروع",
 "setTreasury": "الخزينة",
 "accountsIndex": "دليل الحسابات",
 "indexesTypes": "أنواع دليل الحسابات",
 "costCenters": "مراكز التكلفة",
 "taxSettings": "إعدادات الضرائب",
 "printers": "الطابعات",
 "users": "المستخدمين",
 "posSale": "نقطة البيع",
 "posInvoices": "فواتير نقطة البيع",
 "dashTitle": "الرئيسية",
 "dashGreeting": "مساء الخير، سارة",
 "dashSub": "هذا أداء {branch} خلال الشهر الحالي.",
 "newSalesInvoice": "فاتورة مبيعات جديدة",
 "purchaseInvoices": "فواتير المشتريات",
 "invoicesWord": "فاتورة",
 "amount": "المبلغ",
 "vsLastMonth": "مقارنة بالشهر الماضي",
 "incomeVsExpenses": "الإيرادات مقابل المصروفات",
 "last6": "آخر 6 أشهر",
 "income": "الإيرادات",
 "topItems": "الأصناف الأكثر مبيعاً",
 "byRevenue": "حسب قيمة المبيعات، هذا الشهر",
 "treasuries": "الخزائن",
 "treasuryBalances": "الأرصدة الحالية",
 "recentInvoices": "أحدث فواتير المبيعات",
 "viewAll": "عرض الكل",
 "invoiceNo": "رقم الفاتورة",
 "account": "الحساب",
 "by": "بواسطة",
 "grandTotal": "الإجمالي",
 "paid": "المدفوع",
 "remaining": "المتبقي",
 "date": "التاريخ",
 "status": "الحالة",
 "stPaid": "مدفوعة",
 "stPartial": "مدفوعة جزئياً",
 "stUnpaid": "غير مدفوعة",
 "quickActions": "إجراءات سريعة",
 "afterSignIn": "الفتح بعد تسجيل الدخول",
 "destDashboard": "لوحة التحكم",
 "destPos": "نقطة البيع",
 "qaPos": "فتح شاشة البيع",
 "openPos": "فتح نقطة البيع",
 "lineQtyWarn": "الكمية ليست متاحة (المخزون {n})",
 "lineCostWarn": "أقل من سعر التكلفة",
 "qaCollect": "تسجيل تحصيل",
 "qaPurchase": "فاتورة مشتريات جديدة",
 "qaItem": "إضافة صنف",
 "qaQuote": "عرض سعر جديد",
 "cash": "كاش",
 "bank": "البنك",
 "chartTable": "جدول البيانات",
 "chartView": "الرسم",
 "month": "الشهر",
 "createInvoice": "إنشاء الفاتورة",
 "createSalesInvoice": "إنشاء فاتورة مبيعات",
 "draft": "مسودة",
 "invoiceNumber": "رقم الفاتورة",
 "invoiceDetails": "بيانات الفاتورة",
 "invoiceDateTime": "تاريخ/وقت الفاتورة",
 "warehouse": "المخزن",
 "customerName": "اسم العميل",
 "selectCustomer": "اختر العميل",
 "newCustomer": "عميل جديد",
 "paidReference": "الرقم المرجعي",
 "note": "ملاحظة",
 "notePh": "ملاحظة اختيارية تُطبع على الفاتورة",
 "vatNo": "الرقم الضريبي",
 "balance": "الرصيد",
 "cashCustomer": "عميل نقدي",
 "invoiceLines": "أصناف الفاتورة",
 "searchBarcode": "ابحث بالباركود",
 "barcodeHint": "جرّب 6281000000011 ثم اضغط Enter",
 "add": "إضافة",
 "addLine": "إضافة سطر",
 "newItem": "صنف جديد",
 "deleteSelected": "حذف",
 "itemName": "اسم الصنف",
 "unitName": "اسم الوحدة",
 "qty": "الكمية",
 "price": "السعر",
 "discountPct": "نسبة الخصم %",
 "discount": "الخصم",
 "net": "الصافي",
 "tax": "الضريبة",
 "taxAmount": "قيمة الضريبة",
 "total": "الإجمالي",
 "selectItem": "اختر الصنف",
 "stock": "المخزون",
 "pieces": "قطعة",
 "sku": "الرمز",
 "lines": "عدد الأسطر",
 "selectAll": "تحديد كل الأسطر",
 "deleteRow": "حذف السطر",
 "noLines": "لا توجد أسطر بعد. أضف سطراً أو امسح باركود.",
 "barcodeNotFound": "لا يوجد صنف بالباركود {x}.",
 "itemAdded": "تمت إضافة {item}.",
 "newItemToast": "في المنتج الكامل يفتح هذا شاشة إضافة صنف في لوحة جانبية.",
 "paymentTitle": "الخصم والسداد",
 "invoiceDiscountPct": "خصم الفاتورة %",
 "invoiceDiscountAmt": "الخصم (مبلغ)",
 "treasury": "الخزينة",
 "treasuryAmt": "المبلغ",
 "addTreasury": "إضافة خزينة",
 "payInFull": "سداد كامل",
 "payLater": "آجل",
 "attachments": "مرفقات الفاتورة",
 "dropFiles": "اسحب الملفات هنا أو اضغط للاختيار",
 "dropHint": "PDF أو JPG أو PNG. تبقى الملفات في المتصفح ولا يتم رفعها.",
 "removeFile": "إزالة الملف",
 "summary": "الملخص",
 "totalBeforeDiscount": "الإجمالي قبل الخصم",
 "subTotal": "الإجمالي قبل الضريبة",
 "vat": "ضريبة القيمة المضافة",
 "assumptionTitle": "افتراض في النموذج:",
 "assumptionCalc": "الأسعار غير شاملة الضريبة. يُطبق خصم السطر، ثم يوزع خصم الفاتورة على الأسطر حسب القيمة، ثم تُحسب الضريبة لكل سطر وتقرب لخانتين. يجب مطابقتها مع قواعد خادم النظام الحالي قبل التطوير.",
 "printOptions": "خيارات الطباعة",
 "saveMode": "بعد الحفظ",
 "without": "بدون",
 "print": "طباعة",
 "thermalPrint": "طباعة حرارية",
 "printLang": "لغة الطباعة",
 "bilingual": "عربي + إنجليزي",
 "arabic": "عربي",
 "english": "إنجليزي",
 "copies": "نسخ الطباعة",
 "qrOnPrint": "رمز QR الخاص بهيئة الزكاة على المطبوع",
 "printAssume": "لغة الطباعة وخيار رمز QR افتراضات في النموذج؛ وضع الحفظ وعدد النسخ من التدقيق.",
 "save": "حفظ",
 "saveAndPrint": "حفظ وطباعة",
 "cancel": "إلغاء",
 "preview": "معاينة",
 "savedToast": "نموذج أولي فقط: لم يتم حفظ الفاتورة {no}. الإجمالي {total}. {mode}",
 "modeWithout": "بدون طباعة.",
 "modePrint": "ستفتح الفاتورة الضريبية A4.",
 "modeThermal": "سترسل إلى الطابعة الحرارية.",
 "needCustomer": "اختر العميل قبل الحفظ.",
 "needLines": "أضف سطراً واحداً على الأقل قبل الحفظ.",
 "customerAdded": "تمت إضافة {name} لهذه الجلسة فقط.",
 "name": "الاسم",
 "mobile": "رقم الجوال",
 "address": "العنوان",
 "vatNumber": "الرقم الضريبي",
 "close": "إغلاق",
 "sar": "ر.س",
 "currency": "ر.س",
 "notInProto": "مجدولة في دفعة لاحقة",
 "notInProtoBody": "هذه الشاشة موجودة في التدقيق وتحتفظ بمكانها في القائمة، وسيتم بناؤها في دفعة لاحقة من النموذج.",
 "auditedPath": "المسار في النظام الحالي",
 "backHome": "العودة للرئيسية",
 "openInvoice": "فتح إنشاء فاتورة مبيعات",
 "demoBadge": "تجريبي",
 "demoTag": "تجريبي",
 "demoAbout": "وضع تجريبي: بيانات وهمية وإجراءات محاكاة. لا يُحفظ أو يُرسل أي شيء.",
 "demoSimError": "محاكاة خطأ في تحميل القوائم",
 "demoReset": "إعادة ضبط البيانات التجريبية",
 "demoAssumptions": "ملاحظات المراجعة والافتراضات",
 "notInDemo": "غير متاح في هذا العرض التجريبي",
 "newInDelta": "جديد في دلتا",
 "previewOnly": "معاينة فقط",
 "notFound": "السجل غير موجود",
 "notFoundBody": "ربما تم حذفه خلال هذه الجلسة التجريبية.",
 "all": "الكل",
 "choose": "اختر…",
 "view": "عرض",
 "edit": "تعديل",
 "delete": "حذف",
 "ok": "حسناً",
 "yesSure": "نعم، متأكد",
 "no": "لا",
 "yes": "نعم",
 "reset": "إعادة تعيين",
 "retry": "إعادة المحاولة",
 "options": "خيارات",
 "customSearch": "بحث مخصص",
 "searchWord": "كلمة البحث",
 "refreshResults": "إعادة تحميل النتائج",
 "columns": "الأعمدة",
 "density": "الكثافة",
 "export": "تصدير",
 "exportCsv": "تصدير CSV (إكسل)",
 "clearAll": "مسح الكل",
 "removeFilter": "إزالة التصفية",
 "fromDate": "من تاريخ",
 "toDate": "إلى تاريخ",
 "dateTime": "التاريخ والوقت",
 "type": "النوع",
 "kind": "النوع",
 "showingOf": "عرض {a}–{b} من {n}",
 "rowsPerPage": "عدد الصفوف",
 "prevPage": "الصفحة السابقة",
 "nextPage": "الصفحة التالية",
 "noResults": "لا توجد نتائج",
 "noResultsBody": "لا توجد سجلات تطابق هذه التصفية. غيّرها أو امسحها لعرض المزيد.",
 "emptyTitle": "لا توجد سجلات بعد",
 "emptyBody": "ستظهر هنا السجلات التي تضيفها.",
 "loadErrorTitle": "تعذّر تحميل النتائج",
 "loadErrorBody": "لم يستجب الخادم. هذا خطأ محاكى من قائمة الوضع التجريبي.",
 "requiredField": "حقل مطلوب",
 "fixRequired": "أكمل الحقول المطلوبة المحددة باللون الأحمر.",
 "confirmDelete": "هل أنت متأكد من الحذف؟",
 "deleteWarn": "بمجرد الحذف لن تتمكن من استرجاعه مرة أخرى.",
 "deletedToast": "تم حذف {x} من هذه الجلسة التجريبية.",
 "refreshedToast": "تم تحديث النتائج.",
 "csvToast": "تم تنزيل ملف CSV يحتوي {n} صفاً على هذا الجهاز.",
 "cantDelete": "لا يمكن حذف هذا السجل",
 "filesStayLocal": "تُحفظ أسماء الملفات فقط ولا يتم رفع أي شيء.",
 "reportDate": "تاريخ التقرير",
 "rowsCount": "{n} صف",
 "backToList": "العودة إلى القائمة",
 "sampleQr": "رمز QR نموذجي وليس رمزاً معتمداً من هيئة الزكاة",
 "printFooter": "مطبوع من النسخة التجريبية لدلتا. ليس مستنداً ضريبياً معتمداً.",
 "receivedBy": "المستلم",
 "approvedBy": "المعتمد",
 "document": "المستند",
 "statement": "البيان",
 "debit": "مدين",
 "credit": "دائن",
 "sub": "الحساب الفرعي",
 "simPosting": "القيد المحاسبي (محاكاة)",
 "kpiNote": "حتى تاريخه ({month})، محسوبة من مستندات العرض التجريبي. تتم مقارنة الاتجاه بنفس الأيام من الشهر السابق.",
 "noRecent": "لا توجد فواتير مبيعات لهذا الفرع بعد.",
 "noTreasuryBranch": "لا توجد خزينة مرتبطة بهذا الفرع.",
 "beforeTax": "قبل الضريبة",
 "lineTotal": "إجمالي السطر",
 "createQuotation": "إنشاء عرض سعر",
 "createPurchaseInvoice": "إنشاء فاتورة مشتريات",
 "editSalesInvoice": "تعديل فاتورة مبيعات",
 "editQuotation": "تعديل عرض السعر",
 "editPurchaseInvoice": "تعديل فاتورة مشتريات",
 "editInvoice": "تعديل الفاتورة",
 "editing": "قيد التعديل",
 "quotationNo": "رقم عرض السعر",
 "newQuotation": "عرض سعر جديد",
 "newPurchaseInvoice": "فاتورة مشتريات جديدة",
 "saleInvoiceTitle": "فاتورة مبيعات",
 "quotationTitle": "عرض سعر",
 "saleRefundTitle": "مرتجع مبيعات",
 "purchaseInvoiceTitle": "فاتورة مشتريات",
 "purchaseRefundTitle": "مرتجع مشتريات",
 "supplierName": "اسم المورد",
 "selectSupplier": "اختر المورد",
 "newSupplier": "مورد جديد",
 "needSupplier": "اختر المورد قبل الحفظ.",
 "selectWarehouse": "يجب عليك اختيار مخزن",
 "overPaid": "مبالغ الخزائن أكبر من إجمالي الفاتورة.",
 "quoteNoPay": "عروض السعر لا تتضمن سداداً، وتبدأ الخزائن عند تحويلها إلى فاتورة مبيعات.",
 "cantEdit": "هذه الفاتورة لا يمكن تعديلها",
 "cantEditBody": "توجد عليها فاتورة مرتجع. احذف المرتجع أولاً أو سجّل التغيير كمرتجع جديد.",
 "showInvoice": "عرض الفاتورة",
 "invoiceData": "بيانات الفاتورة",
 "invoiceItems": "أصناف الفاتورة",
 "invoiceRefund": "مرتجع الفاتورة",
 "originalInvoice": "الفاتورة الأصلية",
 "refund": "مرتجع",
 "refundedAmount": "المبلغ المرتجع",
 "refundTreasury": "صُرف المرتجع من",
 "noPayments": "لا يوجد سداد من خزينة، والمبلغ كاملاً على الحساب.",
 "relatedRefunds": "المرتجعات المرتبطة",
 "noRefunds": "لا توجد مرتجعات على هذه الفاتورة.",
 "noAttachments": "لا توجد مرفقات.",
 "cantDeleteRefunds": "على هذه الفاتورة مرتجعات. احذف المرتجعات أولاً.",
 "savedDocToast": "تم حفظ {no} في هذه الجلسة التجريبية. الإجمالي {total}.",
 "updatedToast": "تم تعديل {no} في هذه الجلسة التجريبية. الإجمالي {total}.",
 "branchFiltered": "يتم عرض {b} فقط (من الشريط العلوي)",
 "noRefundsYet": "لا توجد مرتجعات بعد",
 "refundHow": "يبدأ المرتجع من فاتورة المبيعات: افتح الفاتورة ثم خيارات › مرتجع الفاتورة.",
 "refundHowP": "يبدأ المرتجع من فاتورة المشتريات: افتح الفاتورة ثم خيارات › مرتجع الفاتورة.",
 "createRefund": "إنشاء مرتجع",
 "refundList": "قائمة المرتجع",
 "addToRefund": "إضافة إلى المرتجع",
 "added": "تمت الإضافة",
 "removeFromRefund": "حذف من قائمة المرتجع",
 "fullyRefunded": "مرتجع بالكامل",
 "qtyToRefund": "الكمية التي سيتم إرجاعها",
 "refundEmpty": "أضف أسطراً من أصناف الفاتورة بالأعلى.",
 "refundTotal": "إجمالي المرتجع",
 "refundNeedLines": "أضف سطراً واحداً على الأقل بكمية إلى قائمة المرتجع.",
 "selectTreasury": "اختر الخزينة.",
 "refundSaved": "تم حفظ المرتجع {no} في هذه الجلسة التجريبية. الإجمالي {total}.",
 "taxInvoice": "فاتورة ضريبية",
 "simplifiedTaxInvoice": "فاتورة ضريبية مبسطة",
 "creditNote": "إشعار دائن",
 "debitNote": "إشعار مدين",
 "quotation": "عرض سعر",
 "purchaseInvoice": "فاتورة مشتريات",
 "customer": "العميل",
 "supplier": "المورد",
 "client": "عميل",
 "newClient": "عميل جديد",
 "editCustomer": "تعديل العميل",
 "editSupplier": "تعديل المورد",
 "maxWithdrawLimit": "الحد الأقصى للسحب",
 "openBalance": "الرصيد الافتتاحي",
 "taxNumber": "الرقم الضريبي",
 "commercialRecord": "السجل التجاري",
 "other": "أخرى",
 "pricing": "التسعير",
 "price_wholesale": "سعر الجملة",
 "price_half": "نصف الجملة",
 "price_retail": "سعر التجزئة",
 "accountIndex": "دليل الحساب",
 "openBalanceHint": "تغييره يعيد ترحيل القيد الافتتاحي في هذا العرض.",
 "vatFormat": "الرقم الضريبي يتكون من 15 رقماً ويبدأ وينتهي بالرقم 3.",
 "mobileFormat": "رقم الجوال يتكون من 10 أرقام ويبدأ بـ 05.",
 "addedToast": "تمت إضافة {x} في هذه الجلسة التجريبية.",
 "updatedPartyToast": "تم تعديل {x} في هذه الجلسة التجريبية.",
 "cantDeleteParty": "توجد عليه فواتير أو سندات، ويتم الاحتفاظ بالسجلات ذات الحركات للدفاتر.",
 "balanceDue": "الرصيد المستحق",
 "balanceOwed": "الرصيد المستحق للمورد",
 "totalInvoiced": "إجمالي المبيعات",
 "totalPurchased": "إجمالي المشتريات",
 "netOfRefunds": "بعد خصم المرتجعات",
 "totalCollected": "إجمالي التحصيل",
 "totalPaid": "إجمالي السداد",
 "limitUsed": "تم استخدام {n} من الحد",
 "noLimit": "لم يحدد حد",
 "accountStatement": "كشف حساب",
 "noInvoicesParty": "لا توجد فواتير لهذا الحساب.",
 "noMoneyParty": "لا توجد سندات لهذا الحساب.",
 "receiptId": "رقم السند",
 "receiptDetails": "تفاصيل السند",
 "employee": "الموظف",
 "partner": "الشريك",
 "costCenter": "مركز التكلفة",
 "collectDateTime": "تاريخ/وقت التحصيل",
 "repaymentDateTime": "تاريخ/وقت السداد",
 "newCollect": "تحصيل جديد",
 "editCollect": "تعديل التحصيل",
 "newPayment": "سداد جديد",
 "editPayment": "تعديل السداد",
 "newExpense": "صرف جديد",
 "editExpense": "تعديل المصروف",
 "newDeposit": "إيداع جديد",
 "editDeposit": "تعديل الإيداع",
 "newWithdraw": "سحب جديد",
 "editWithdraw": "تعديل السحب",
 "newSalary": "راتب جديد",
 "newLoan": "سلفة جديدة",
 "newReward": "مكافأة جديدة",
 "newDeduction": "خصم جديد",
 "editReceipt": "تعديل السند",
 "receiptVoucher": "سند قبض",
 "paymentVoucher": "سند صرف",
 "expenseVoucher": "سند مصروف",
 "depositVoucher": "سند إيداع",
 "withdrawVoucher": "سند سحب",
 "salaryVoucher": "سند راتب",
 "loanVoucher": "سند سلفة",
 "rewardVoucher": "سند مكافأة",
 "deductionVoucher": "سند خصم",
 "salariesOne": "راتب",
 "loansOne": "سلفة",
 "rewardsOne": "مكافأة",
 "deductionsOne": "خصم",
 "amountPositive": "أدخل مبلغاً أكبر من صفر لخزينة واحدة على الأقل.",
 "treasuryRepeated": "لا يمكن تكرار الخزينة نفسها.",
 "voucherSaved": "تم حفظ {no} في هذه الجلسة التجريبية. المبلغ {total}.",
 "voucherUpdated": "تم تعديل {no} في هذه الجلسة التجريبية.",
 "src_Sale": "فاتورة مبيعات",
 "src_SaleRefund": "مرتجع مبيعات",
 "src_Purchase": "فاتورة مشتريات",
 "src_PurchaseRefund": "مرتجع مشتريات",
 "src_Collect": "تحصيل",
 "src_Payment": "سداد",
 "src_Opening": "رصيد افتتاحي",
 "src_Expense": "مصروف",
 "src_Deposit": "إيداع",
 "src_Withdraw": "سحب",
 "src_Salary": "راتب",
 "src_Loan": "سلفة",
 "src_Reward": "مكافأة",
 "src_Deduction": "خصم",
 "src_CashTransfer": "تحويل نقدية",
 "src_Depreciation": "إهلاك",
 "src_AssetPurchase": "مشتريات أصول",
 "src_Journal": "قيد يومية",
 "src_BeginningInventory": "مخزون أول المدة",
 "src_Corrupted": "هالك",
 "src_Transfer": "تحويل مخزني",
 "src_Inventory": "جرد",
 "src_Compromise": "تسوية",
 "journal": "القيد",
 "journalId": "رقم القيد",
 "journalNo": "رقم القيد",
 "belongType": "ينتمي إلى",
 "newJournal": "قيد جديد",
 "editJournal": "تعديل القيد",
 "viewJournal": "عرض القيد",
 "journalDateTime": "تاريخ / وقت القيد",
 "journalLines": "بنود القيد",
 "journalAttachments": "مرفقات القيد",
 "journalLinesHint": "كل بند إما مدين أو دائن.",
 "statementPh": "وصف القيد",
 "debitNotEqualCredit": "المدين والدائن غير متساويين",
 "difference": "الفرق",
 "journalNeedLines": "أضف بندين على الأقل بحساب ومبلغ.",
 "journalLineInvalid": "كل بند يحتاج إلى حساب ومبلغ مدين أو دائن.",
 "manualJournals": "يدوية",
 "autoJournals": "من المستندات",
 "autoJournal": "منشأ من مستند",
 "autoJournalHint": "تم إنشاء هذا القيد من مستند. لتغييره عدّل المستند أو احذفه.",
 "autoJournalDelete": "هذا القيد تابع لمستند ويُحذف بحذفه.",
 "openSource": "فتح المستند",
 "selectRow": "تحديد السطر",
 "preparedBy": "أعدّه",
 "newTransfer": "تحويل جديد",
 "viewTransfer": "عرض التحويل",
 "transferDetails": "بيانات التحويل",
 "transferVoucher": "سند تحويل نقدية",
 "fromTreasury": "الخزينة المحول منها",
 "toTreasury": "الخزينة المحول إليها",
 "depositDate": "تاريخ الإيداع",
 "depositNumber": "رقم الإيداع",
 "deposite": "إيداع",
 "treasurySame": "لا يمكن أن تكون الخزينتان متشابهتين",
 "availableBalance": "الرصيد {x}",
 "transferSaved": "تم حفظ التحويل {no} ({total}). عملية محاكاة ولم يُرسل شيء.",
 "partnerName": "اسم الشريك",
 "partnerTitle": "الاسم",
 "phone": "رقم الهاتف",
 "newPartner": "شريك جديد",
 "editPartner": "تعديل الشريك",
 "editTransfer": "تعديل التحويل",
 "balanced": "متوازن",
 "journalSaved": "تم حفظ القيد ({total}). عملية محاكاة ولم يُرسل شيء.",
 "journalUpdated": "تم تعديل القيد ({total}). عملية محاكاة.",
 "itemData": "بيانات الصنف",
 "itemSettings": "النوع والضريبة والعرض",
 "createItem": "إنشاء صنف",
 "editItem": "تعديل الصنف",
 "saveItem": "حفظ الصنف",
 "itemCode": "كود الصنف",
 "category": "التصنيف",
 "categoryName": "اسم التصنيف",
 "categoryTitleAr": "اسم التصنيف بالعربي",
 "categoryTitleEn": "اسم التصنيف بالإنجليزية",
 "nameAr": "الاسم بالعربي",
 "nameEn": "الاسم بالإنجليزية",
 "descriptionAr": "الوصف بالعربية",
 "descriptionEn": "الوصف بالإنجليزية",
 "minQty": "أقل كمية",
 "itemImage": "صورة الصنف",
 "chooseImage": "اختر صورة (تبقى في المتصفح)",
 "remove": "إزالة",
 "itemKind": "نوع الصنف",
 "taxType": "نوع الضريبة",
 "priceIncludeTax": "السعر يشمل الضريبة",
 "quickList": "القائمة السريعة",
 "quickListPos": "إظهار في القائمة السريعة لنقطة البيع",
 "units": "الوحدات",
 "unit": "الوحدة",
 "piecesNo": "معامل الوحدة",
 "unitBarcode": "باركود الوحدة",
 "unitBarcodes": "باركود الوحدة",
 "barcode": "الباركود",
 "barcodes": "الباركودات",
 "unitsHint": "السطر الأول هو الوحدة الأساسية (قطعة واحدة). الوحدات الأخرى تضم عدة قطع.",
 "baseUnitHint": "الوحدة الأساسية دائماً قطعة واحدة",
 "addBarcodePh": "اكتب باركود واضغط Enter",
 "autoGenerate": "توليد تلقائي",
 "deleteBarcode": "حذف الباركود",
 "barcodeTaken": "الباركود {x} مستخدم لوحدة أخرى.",
 "codeTaken": "كود الصنف مستخدم بالفعل.",
 "unitRowInvalid": "سطر الوحدة {n}: المعامل يجب أن يكون 1 أو أكثر وسعر التجزئة مطلوب.",
 "unitDuplicate": "نفس الوحدة والمعامل مكررة.",
 "itemSaved": "تمت إضافة {x} في هذه الجلسة التجريبية.",
 "itemUpdated": "تم تعديل {x} في هذه الجلسة التجريبية.",
 "hasNoStock": "بدون مخزون",
 "noStockKind": "بدون مخزون",
 "hasQty": "لديه كمية (تتبع المخزون)",
 "lowStock": "مخزون منخفض",
 "stockByWarehouse": "المخزون حسب المخزن",
 "recentMovements": "آخر الحركات",
 "noMovements": "لا توجد حركات بعد.",
 "barcodeHintItems": "امسح أو اكتب باركود وحدة واضغط Enter لفتح الصنف.",
 "cantDeleteItem": "هذا الصنف مستخدم في فواتير ولا يمكن حذفه.",
 "newCategory": "تصنيف جديد",
 "editCategory": "تعديل التصنيف",
 "newUnit": "وحدة جديدة",
 "editUnit": "تعديل الوحدة",
 "itemsCount": "الأصناف",
 "nameTaken": "هذا الاسم موجود بالفعل.",
 "cantDeleteCategory": "توجد أصناف بهذا التصنيف.",
 "cantDeleteUnit": "توجد أصناف بهذه الوحدة.",
 "newItemKind": "نوع صنف جديد",
 "editItemKind": "تعديل نوع الصنف",
 "salesAccount": "حساب المبيعات",
 "salesRefundAccount": "حساب مرتجع المبيعات",
 "salesCostAccount": "حساب تكلفة المبيعات",
 "inventoryAccount": "حساب المخزون",
 "corruptedAccount": "حساب الهالك",
 "discountAccount": "حساب الخصم",
 "cantDeleteKind": "توجد أصناف من هذا النوع.",
 "kindQtyLocked": "أصناف هذا النوع موجودة في فواتير، لذلك لا يمكن تغيير تتبع المخزون.",
 "copiesNo": "عدد النسخ",
 "noBarcode": "بدون باركود",
 "selectedN": "تم تحديد {n}",
 "selectToPrint": "حدد وحدة واحدة على الأقل لها باركود.",
 "labelHint": "تصميم ملصق تجريبي. مقاس الملصق ومحتواه من إعدادات باركود الفرع في النظام الفعلي.",
 "cantDeletePartner": "هذا الشريك مستخدم في سندات أو قيود.",
 "newWarehouse": "مخزن جديد",
 "editWarehouse": "تعديل المخزن",
 "warehouseName": "المخزن",
 "cantDeleteWarehouse": "توجد مستندات مخزنية على هذا المخزن، لذلك لا يمكن حذفه.",
 "whAccountTaken": "يستخدم مخزن آخر دليل الحساب هذا بالفعل.",
 "stockValue": "قيمة المخزون",
 "itemsInStock": "أصناف بالمخزون",
 "viewStock": "عرض المخزون",
 "newBeginningHere": "مخزون أول مدة جديد",
 "newCountHere": "جرد جديد",
 "averagePrice": "متوسط السعر",
 "actualQty": "الكمية الفعلية",
 "systemQtyHint": "الكمية هي كمية النظام في هذا المخزن عند إضافة السطر.",
 "kindInventory": "جرد",
 "kindCompromise": "تسوية",
 "kindBeginning": "مخزون أول المدة",
 "kindCorrupted": "هالك",
 "kindTransfer": "تحويل",
 "invCompTitle": "الجرد والتسوية",
 "newInvoice": "فاتورة جديدة",
 "newInventory": "جرد جديد",
 "invoiceType": "نوع الفاتورة",
 "biTitle": "مخزون أول المدة",
 "crTitle": "فاتورة هالك",
 "trTitle": "تحويل مخزني",
 "ivTitle": "جرد",
 "cpTitle": "تسوية",
 "fromWarehouse": "من المخزن",
 "toWarehouse": "إلى المخزن",
 "selectWarehouseFirst": "يجب عليك اختيار مخزن أولاً",
 "noInventoryChanges": "لا يوجد اختلاف في جرد الأصناف",
 "changeWhTitle": "تغيير المخزن؟",
 "changeWhLoses": "عند تغيير المخزن، ستقوم بحذف جميع الأصناف.",
 "changeWh": "تغيير المخزن",
 "sameWarehouse": "لا يمكن أن يكون مخزن المصدر هو نفسه مخزن الوجهة.",
 "stockNeedLines": "أضف صنفاً واحداً على الأقل.",
 "stockLineInvalid": "كل سطر يحتاج إلى صنف ووحدة وكمية أكبر من صفر.",
 "countLineInvalid": "كل سطر يحتاج إلى صنف ووحدة وكمية فعلية صفر أو أكثر.",
 "availableN": "المتاح {n}",
 "exceedsStock": "أكثر من المخزون المتاح",
 "exceedsTitle": "حفظ مع مخزون سالب؟",
 "exceedsBody": "{n} سطر يتجاوز المخزون المتاح، وسيصبح رصيد المخزن سالباً.",
 "saveAnyway": "حفظ على أي حال",
 "loadAllItems": "تحميل كل الأصناف المتوفرة",
 "loadedN": "تم تحميل {n} صنف",
 "alreadyListed": "{x} موجود بالفعل في القائمة.",
 "stockDocSaved": "تم حفظ {no} · {total}",
 "stockDocUpdated": "تم تعديل {no} · {total}",
 "diffValue": "قيمة الفرق",
 "countedValue": "قيمة الجرد",
 "linesCount": "الأسطر",
 "stockLinesHint": "امسح الباركود أو أضف سطراً، ثم اختر الصنف والوحدة.",
 "noStockRows": "لا يوجد مخزون بعد",
 "noStockBody": "يظهر المخزون هنا بعد مخزون أول المدة أو المشتريات أو التحويلات.",
 "stockOnHand": "المخزون",
 "stockPrintTitle": "المخزون",
 "belowMin": "أقل من الحد الأدنى",
 "baseUnitNote": "الكميات بالوحدة الأساسية لكل صنف.",
 "stockDocEmpty": "لا توجد مستندات بعد",
 "stockDocEmptyBody": "أنشئ أول مستند من زر فاتورة جديدة.",
 "whEmpty": "لا توجد مخازن بعد",
 "whEmptyBody": "أضف مخزناً لكل مكان تحتفظ فيه بالمخزون.",
 "emailFormat": "أدخل بريداً إلكترونياً صحيحاً.",
 "employeeName": "اسم الموظف",
 "nationality": "الجنسية",
 "role": "الوظيفة",
 "job": "الوظيفة",
 "city": "المدينة",
 "neighborhood": "الحي",
 "emailF": "البريد الإلكتروني",
 "citizenF": "مواطن",
 "foreigner": "أجنبي",
 "citizenship": "الجنسية والإقامة",
 "nationalId": "رقم الهوية / الإقامة",
 "renewalDate": "تاريخ التجديد",
 "passportNo": "رقم جواز السفر",
 "expiryDate": "تاريخ الانتهاء",
 "basicSalary": "الراتب الأساسي",
 "incentive": "الحوافز",
 "totalSalary": "إجمالي الراتب",
 "bankName": "اسم البنك",
 "ibanF": "الآيبان",
 "accountNo": "رقم الحساب",
 "transferMethod": "طريقة التحويل",
 "tmBank": "تحويل بنكي",
 "tmCash": "نقداً",
 "residence": "الإقامة",
 "residenceAmount": "قيمة الإقامة",
 "residenceRenewal": "تجديد الإقامة",
 "residenceExpiry": "انتهاء الإقامة",
 "residenceTotal": "إجمالي تكلفة الإقامة",
 "medicalInsurance": "التأمين الطبي",
 "socialInsurance": "التأمين الاجتماعي",
 "healthCert": "الشهادة الصحية",
 "healthExpiry": "انتهاء الشهادة الصحية",
 "annualLeave": "الإجازة السنوية (أيام)",
 "annualPaid": "الإجازة السنوية مدفوعة",
 "ticket": "تذكرة سفر",
 "casualLeave": "الإجازة العارضة (أيام)",
 "sickLeave": "الإجازة المرضية (أيام)",
 "personalData": "البيانات الشخصية",
 "financialData": "البيانات المالية",
 "vacations": "الإجازات",
 "empAttachments": "المرفقات",
 "nextStep": "التالي",
 "prevStep": "رجوع",
 "stepOf": "الخطوة {a} من {b}",
 "newEmployee": "موظف جديد",
 "addEmployee": "إضافة موظف",
 "editEmployee": "تعديل الموظف",
 "showEmployee": "عرض الموظف",
 "uploadIdentity": "يجب عليك إرفاق الهوية",
 "identityHint": "صورة الهوية (مطلوبة) وأي مستندات أخرى. الملفات تبقى في هذا المتصفح.",
 "employeeSaved": "تم حفظ {x}",
 "cantDeleteEmployee": "لهذا الموظف سندات ولا يمكن حذفه.",
 "empVouchers": "السندات",
 "noVouchers": "لا توجد سندات بعد",
 "paidThisYear": "المدفوع في 2026",
 "loanBalance": "السلف ناقص الخصومات",
 "newAllowance": "بدل جديد",
 "editAllowance": "تعديل البدل",
 "cantDeleteAllowance": "يحصل موظفون على هذا البدل.",
 "employeesCount": "الموظفون",
 "salaryGroup": "رواتب مجمعة",
 "searchByStore": "بحث بالفرع",
 "selectBranchFirst": "اختر فرعاً لعرض موظفيه.",
 "selectTreasuryEach": "يجب عليك اختيار خزينة لكل مجموعة",
 "totalEqualTreasury": "إجمالي الخزن يجب أن يساوي الإجمالي",
 "paidThisMonth": "مدفوع هذا الشهر",
 "salaryRunSaved": "تم إنشاء {n} سند راتب · {total}",
 "noEmpSelected": "حدد موظفاً واحداً على الأقل.",
 "payTo": "صرف",
 "salaryRunHint": "يحصل كل موظف محدد على سند راتب واحد بإجمالي راتبه من الخزينة المختارة.",
 "monthsWhole": "أدخل عدداً صحيحاً من الشهور.",
 "depSameAccount": "يجب أن يختلف حساب الأصل عن حساب الإهلاك.",
 "monthShort": "شهر",
 "assetName": "اسم الأصل",
 "fixedAssetAmount": "قيمة الأصل الثابت",
 "depreciationMonthly": "إهلاك شهري",
 "fixedAssetKind": "نوع الأصل الثابت",
 "startWorkDate": "بداية فترة العمل",
 "calcMonthly": "احتساب الإهلاك الشهري",
 "newFixedAsset": "أصل ثابت جديد",
 "editFixedAsset": "تعديل الأصل الثابت",
 "kindName": "اسم النوع",
 "depPeriod": "مدة الإهلاك (بالشهور)",
 "depAccount": "حساب الإهلاك",
 "depExpAccount": "حساب مصروف الإهلاك",
 "newAssetKind": "نوع أصل ثابت جديد",
 "editAssetKind": "تعديل نوع الأصل",
 "cantDeleteAssetKind": "توجد أصول من هذا النوع.",
 "assetDeportedLock": "بمجرد ترحيل الإهلاك، لا يمكن تعديل الأصل",
 "undeportWarn": "بعد إلغاء ترحيل الإهلاك، لن يمكنك استعادة القيد",
 "deport": "ترحيل",
 "undeport": "إلغاء الترحيل",
 "isDeported": "تم الترحيل",
 "deportTitle": "ترحيل الإهلاك؟",
 "deportBody": "سيتم ترحيل {amt} إلى حسابات الإهلاك.",
 "deportedToast": "تم ترحيل {x}",
 "undeportedToast": "تم إلغاء ترحيل {x}",
 "deportUpTo": "ترحيل الفترات المستحقة",
 "deportDueBody": "سيتم ترحيل {n} فترة حتى {d} بقيمة ({amt}).",
 "nothingDue": "لا توجد فترات مستحقة.",
 "assetTitle": "اسم الأصل",
 "fromF": "من",
 "toF": "إلى",
 "endDate": "تاريخ النهاية",
 "deportedYes": "مُرحّل",
 "deportedNo": "غير مُرحّل",
 "bookValue": "القيمة الدفترية",
 "accumulatedDep": "مجمع الإهلاك",
 "scheduleRows": "جدول الإهلاك",
 "noDepreciation": "بدون إهلاك شهري",
 "createAssetsPurchase": "مشتريات أصول جديدة",
 "assetInvoice": "فاتورة شراء أصول",
 "paidTotal": "المدفوع",
 "paidAmount": "المبلغ المدفوع",
 "chooseKindTax": "اختر نوع أصل ونوع ضريبة لكل صنف",
 "assetLineInvalid": "كل سطر يحتاج إلى بيان وكمية وسعر.",
 "paidOverGrand": "لا يمكن أن يتجاوز المبلغ المدفوع الإجمالي.",
 "assetsCreated": "تم حفظ {no} · أضيف {n} أصل",
 "cantDeleteAssetInvoice": "تم ترحيل إهلاك أصول هذه الفاتورة.",
 "assetFromInvoice": "من الفاتورة",
 "linkedAssets": "أصول هذه الفاتورة",
 "myAccount": "حسابي",
 "unsavedChanges": "تغييرات غير محفوظة",
 "allSaved": "تم حفظ كل التغييرات",
 "discardChanges": "تجاهل التغييرات",
 "settingsOrg": "إعدادات الشركة",
 "orgData": "بيانات المؤسسة",
 "orgDataHint": "تظهر في الفواتير والسندات والتقارير.",
 "logo": "الشعار",
 "logoHint": "PNG أو JPG. يبقى في هذا المتصفح.",
 "removeLogo": "إزالة الشعار",
 "logoType": "اختر ملف صورة.",
 "vatHint": "15 رقماً، يبدأ وينتهي بالرقم 3.",
 "contactInfo": "التواصل",
 "landline": "الهاتف الثابت",
 "fax": "الفاكس",
 "addressF": "العنوان",
 "country": "البلد",
 "region": "الحي",
 "street": "الشارع",
 "controlAccounts": "الحسابات الافتراضية",
 "controlAccountsHint": "تُرحّل أرصدة العملاء والموردين إلى هذين الحسابين في دليل الحسابات.",
 "customerAccount": "دليل حساب العملاء",
 "supplierAccount": "دليل حساب الموردين",
 "sameControlAccount": "يجب أن يختلف حساب العملاء عن حساب الموردين.",
 "controlAccountsChange": "تغيير الحسابات الافتراضية؟",
 "controlAccountsBody": "في هذا العرض تنتقل كل أرصدة العملاء والموردين إلى الحسابات الجديدة. لم نتحقق من طريقة تعامل النظام الحالي مع القيود السابقة.",
 "orgSaved": "تم حفظ إعدادات الشركة في هذه الجلسة التجريبية.",
 "settingsBranches": "إعدادات الفروع",
 "newStore": "فرع جديد",
 "newBranch": "فرع جديد",
 "editBranch": "تعديل الفرع",
 "addressAr": "العنوان بالعربية",
 "addressEn": "العنوان بالإنجليزية",
 "monthlyExpense": "المصاريف الشهرية",
 "currencyF": "العملة",
 "phoneFormat": "يجب أن يبدأ الهاتف بالرقم 0 ويتكون من 9 أو 10 أرقام.",
 "barcodeSettings": "إعدادات الباركود",
 "branchInUse": "هذا الفرع مرتبط بمخازن أو خزائن أو مستخدمين أو موظفين أو مستندات.",
 "barcodeGeneral": "حقول الباركود العامة",
 "barcodeWeight": "حقول باركود الميزان",
 "sizeF": "الحجم",
 "heightF": "الطول",
 "widthF": "العرض",
 "marginTop": "الهامش العلوي",
 "marginBottom": "الهامش السفلي",
 "marginRight": "الهامش الأيمن",
 "marginLeft": "الهامش الأيسر",
 "labelShows": "يظهر على الملصق",
 "showTitle": "إظهار عنوان الملصق",
 "showText": "إظهار أرقام الباركود",
 "showName": "إظهار اسم الصنف",
 "showPrice": "إظهار السعر",
 "weightActive": "تفعيل الوزن",
 "weightLeftFlag": "معرّف اليسار للميزان",
 "weightCodeLen": "عدد أرقام كود الوزن",
 "weightQtyLen": "أرقام كمية الوزن",
 "weightCheckLen": "أرقام فحص الوزن",
 "weightOffHint": "فعّله لقراءة كود الصنف والوزن من ملصقات الميزان.",
 "labelPreview": "معاينة الملصق",
 "labelPreviewHint": "معاينة تقريبية بصنف تجريبي. المقاسات بالمليمتر.",
 "weightSample": "مثال باركود الميزان",
 "weightNot13": "مجموع الأطوال {n} رقماً، وملصقات الميزان EAN-13 تستخدم 13 رقماً.",
 "weight13ok": "13 رقماً، مطابق لـ EAN-13.",
 "positiveNumber": "أدخل رقماً أكبر من صفر.",
 "zeroOrMore": "أدخل صفراً أو أكثر.",
 "wholeNumber": "أدخل رقماً صحيحاً.",
 "barcodeSaved": "تم حفظ إعدادات باركود {x} في هذه الجلسة التجريبية.",
 "settingsTreasury": "إعدادات الخزينة",
 "treasuryName": "اسم الخزينة",
 "newTreasury": "خزينة جديدة",
 "bankDetails": "بيانات البنك",
 "accountNumber": "رقم الحساب",
 "commissionPct": "نسبة العمولة %",
 "commissionAccount": "حساب العمولة",
 "commissionTaxType": "نوع ضريبة العمولة",
 "commissionAccountReq": "اختر حساب العمولة عندما تكون العمولة أكبر من صفر.",
 "accountTaken": "هذا الحساب مرتبط بخزينة أو مخزن آخر.",
 "treasuryAccountLocked": "توجد قيود على هذه الخزينة، لذلك لا يمكن تغيير حسابها.",
 "ibanFormat": "يجب أن يبدأ الأيبان بـ SA ويليه 22 رقماً.",
 "percentRange": "يجب أن تكون النسبة بين 0 و 100.",
 "treasuryInUse": "توجد سندات أو مدفوعات أو قيود على هذه الخزينة.",
 "drShort": "مدين",
 "crShort": "دائن",
 "accountHasPostings": "توجد قيود على هذا الحساب.",
 "accountLinked": "هذا الحساب مرتبط في الإعدادات (خزينة أو مخزن أو نوع صنف أو ضريبة أو نوع أصل أو الحسابات الافتراضية).",
 "indexCode": "كود الحساب",
 "codeHint": "يبدأ بكود الدليل الرئيسي.",
 "mainIndex": "الدليل الرئيسي",
 "codeDigits": "يجب أن يتكون الكود من أرقام فقط.",
 "codePrefix": "يجب أن يبدأ الكود بـ {p} وأن يكون أطول منه.",
 "accCodeTaken": "هذا الكود مستخدم.",
 "accountMoveLocked": "لا يمكن نقل حساب عليه قيود إلى مجموعة رئيسية أخرى.",
 "newAccountIndex": "دليل حساب جديد",
 "editAccountIndex": "تعديل دليل الحساب",
 "newIndex": "نوع جديد",
 "newIndexType": "نوع دليل حسابات جديد",
 "editIndexType": "تعديل نوع دليل الحسابات",
 "typeL1Locked": "يحتوي على حسابات، لذلك لا يمكن تغيير مجموعته الرئيسية.",
 "typeCodeFull": "تحتوي هذه المجموعة الرئيسية على 9 أنواع.",
 "accountsCount": "الحسابات",
 "level1Fixed": "المستوى الأول ثابت: الأصول، الخصوم، حقوق الملكية، المصروفات، الإيرادات.",
 "typeHasAccounts": "يحتوي هذا النوع على حسابات.",
 "chartTree": "شجرة الحسابات",
 "chartOfAccounts": "دليل الحسابات",
 "noAccountsYet": "لا توجد حسابات بعد",
 "searchAccount": "ابحث بالكود أو الاسم",
 "expandAll": "توسيع الكل",
 "collapseAll": "طي الكل",
 "treeBalanceHint": "الأرصدة إضافة جديدة في دلتا، محسوبة من القيود التجريبية.",
 "postingsCount": "عدد القيود",
 "description": "البيان",
 "accountData": "بيانات الحساب",
 "movements": "الحركات",
 "lastN": "آخر {n}",
 "costCentersSettings": "إعدادات مراكز التكلفة",
 "newCostCenter": "مركز تكلفة جديد",
 "editCostCenter": "تعديل مركز التكلفة",
 "noCostCenters": "لا توجد مراكز تكلفة بعد",
 "noCostCentersBody": "أضف مركزاً لتصنيف بنود القيود.",
 "costCenterInUse": "توجد بنود قيود على مركز التكلفة هذا.",
 "percentage": "النسبة",
 "newTax": "ضريبة جديدة",
 "editTax": "تعديل الضريبة",
 "taxRateLocked": "توجد مستندات بهذه الضريبة، لذلك لا يمكن تغيير نسبتها.",
 "taxInUse": "توجد أصناف أو مستندات أو خزائن تستخدم هذه الضريبة.",
 "printersSetting": "إعدادات الطابعة",
 "newPrinter": "طابعة جديدة",
 "editPrinter": "تعديل الطابعة",
 "port": "المنفذ",
 "hardMarginX": "الهامش الثابت X",
 "hardMarginY": "الهامش الثابت Y",
 "paperWidth": "عرض الورق",
 "paperWidthHint": "بالمليمتر، غالباً 58 أو 80.",
 "ipFormat": "أدخل عنوان IPv4 مثل 192.168.1.50.",
 "portFormat": "يجب أن يكون المنفذ رقماً من 1 إلى 65535.",
 "testPrint": "طباعة تجريبية",
 "testPrintSim": "نموذج أولي: لم تُرسل صفحة تجريبية إلى {x} ({ip}).",
 "printerInUse": "{n} مستخدمين يطبعون على هذه الطابعة.",
 "newUser": "مستخدم جديد",
 "editUser": "تعديل مستخدم",
 "enterPhone": "أدخل رقم الجوال",
 "passwordKeep": "اتركها فارغة للإبقاء على كلمة المرور الحالية.",
 "passwordRule": "6 أحرف على الأقل.",
 "allowedTreasuries": "الخزائن المسموح بها لهذا المستخدم.",
 "allowedWarehouses": "المخازن المسموح بها لهذا المستخدم.",
 "ticketPrinter": "طابعة الفواتير",
 "ticketCopies": "نسخ الطباعة",
 "ticketPrinting": "الطباعة",
 "activeF": "فعال",
 "inactive": "غير فعال",
 "adminSeesAll": "المسؤول يرى كل شيء، ولا يمكن تقييد صلاحياته.",
 "phoneTaken": "رقم الجوال مستخدم لمستخدم آخر.",
 "printerRequired": "اختر طابعة الفواتير عند تفعيل الطباعة.",
 "copiesRange": "عدد النسخ من 1 إلى 5.",
 "userLimit": "تسمح خطتك بـ {n} مستخدمين فعالين. قم بترقية الخطة أو أضف مستخدمين من السلة.",
 "userAdded": "تمت إضافة {x} بمعرّف {id}. صلاحية الرئيسية فقط مفعّلة.",
 "userPasswordSet": "تم تحديث {x}. لم تُخزَّن كلمة المرور الجديدة في هذا العرض.",
 "you": "أنت",
 "userId": "معرّف المستخدم",
 "administrator": "مسؤول",
 "userKind": "مستخدم",
 "copiesNumber": "عدد النسخ",
 "seatsUsed": "{a} من {b} مستخدمين فعالين في خطتك",
 "addUsers": "إضافة مستخدمين",
 "editPermission": "تعديل صلاحية",
 "cantDeleteSelf": "لا يمكنك حذف المستخدم الذي سجلت الدخول به.",
 "cantDeleteAdmin": "لا يمكن حذف حسابات المسؤول من هنا.",
 "cantLockSelf": "لا يمكنك إزالة صلاحيتك على المستخدمين.",
 "permsSaved": "تم حفظ صلاحيات {x} في هذه الجلسة التجريبية (تغيير {n}).",
 "allOn": "تفعيل الكل",
 "feature": "الميزة",
 "updateF": "تعديل",
 "otherPerms": "صلاحيات أخرى",
 "permHint": "تفعيل الإضافة أو التعديل أو الحذف يفعّل العرض تلقائياً.",
 "tabAllOn": "تفعيل التبويب كله",
 "tabAllOff": "إيقاف التبويب كله",
 "user": "المستخدم",
 "permsOn": "الصلاحيات المفعلة",
 "savePerms": "حفظ الصلاحيات",
 "tabInvoices": "الفواتير",
 "tabWarehouses": "المخازن",
 "tabGeneralAccounts": "الحسابات العامة",
 "tabFixedAssets": "الأصول الثابتة",
 "tabHr": "الموارد البشرية",
 "tabSettings": "الإعدادات",
 "tabReports": "التقارير",
 "repAccounting": "التقارير المحاسبية",
 "repFinancial": "التقارير المالية",
 "repInvoices": "تقارير الفواتير",
 "repEmployees": "تقارير الموظفين",
 "repParties": "تقارير العملاء والموردين",
 "repTreasury": "تقارير الخزينة",
 "repTaxes": "تقارير الضرائب",
 "repWarehouses": "تقارير المخازن",
 "repAssets": "تقارير الأصول",
 "clientArea": "منطقة العميل",
 "accountInfo": "معلومات الحساب",
 "subscriptions": "الاشتراكات",
 "billingInvoices": "الفواتير",
 "orgName": "اسم المؤسسة",
 "activity": "النشاط",
 "caInfoHint": "لتعديل هذه البيانات انتقل إلى",
 "currentPlan": "الخطة الحالية",
 "expired": "منتهي",
 "billingCycle": "دورة الفوترة",
 "yearly": "سنوي",
 "monthlyF": "شهري",
 "daysLeft": "متبقٍ {n} يوماً",
 "renewPlan": "تجديد",
 "changePlan": "تغيير الخطة",
 "subscriptionNo": "رقم الاشتراك",
 "plan": "الخطة",
 "periodF": "الفترة",
 "additionalUsers": "مستخدمين إضافيين",
 "additionalWarehouses": "مخازن إضافية",
 "startDate": "تاريخ البداية",
 "renewalPrice": "سعر التجديد",
 "paymentMethod": "طريقة الدفع",
 "onlinePayment": "دفع أونلاين",
 "bankTransfer": "تحويل بنكي",
 "amountInclVat": "المبلغ شامل الضريبة",
 "underReview": "قيد المراجعة",
 "unpaid": "غير مدفوعة",
 "payNow": "ادفع الآن",
 "noBills": "لا توجد فواتير اشتراك بعد",
 "billPrintSim": "نموذج أولي: لم تتم طباعة {no}.",
 "renewSoon": "ينتهي اشتراكك خلال {n} يوماً.",
 "mod_pos": "نقاط البيع",
 "mod_accounting": "المحاسبة",
 "mod_hr": "الموارد البشرية",
 "mod_asset": "الأصول الثابتة",
 "mod_linking": "الربط مع البرامج",
 "payment": "الدفع",
 "paymentSimHint": "محاكاة. لا تُطلب بيانات بطاقة ولا يتم خصم أي مبلغ.",
 "transferHint": "ارفع إيصال التحويل البنكي. يبقى في هذا المتصفح وتنتظر الفاتورة المراجعة.",
 "cardHint": "النظام الحالي يفتح صفحة الدفع URWAY هنا. هذا العرض يتجاوزها.",
 "transferReceipt": "إيصال التحويل",
 "paymentConfirming": "جارٍ التأكد من الدفع…",
 "paymentOk": "تم الدفع بنجاح (محاكاة): {a}.",
 "transferUploaded": "تم إرفاق إيصال تحويل بمبلغ {a}. الفاتورة قيد المراجعة (محاكاة).",
 "planTooSmall": "هذه الخطة لا تكفي",
 "planTooSmallBody": "أضف {u} مستخدمين و{w} مخازن على الأقل، أو اختر خطة أكبر.",
 "yearShort": "سنة",
 "planIncludes": "{u} مستخدمين · {w} مخازن",
 "choosePlan": "اختر الخطة",
 "planOptions": "الفترة والإضافات",
 "yearlySaves": "السعر السنوي يعادل 10 أشهر.",
 "planInfo": "تفاصيل الخطة",
 "planPrice": "سعر الخطة",
 "additionalUsersCost": "تكلفة المستخدمين الإضافيين",
 "additionalWarehousesCost": "تكلفة المخازن الإضافية",
 "vat15": "ضريبة القيمة المضافة 15%",
 "planPriceTotal": "إجمالي سعر الخطة",
 "generalLedger": "دفتر الأستاذ العام",
 "trialTotals": "ميزان المراجعة بالمجاميع والأرصدة",
 "trialBalances": "ميزان المراجعة بالأرصدة",
 "chartStatement": "كشف حساب من دليل الحسابات",
 "receiptPayment": "تقرير المقبوضات والمدفوعات",
 "incomeStatement": "قائمة الدخل",
 "balanceSheet": "الميزانية العمومية",
 "invoicesDetails": "تفاصيل الفواتير",
 "invoicesProfits": "أرباح الفواتير",
 "employeeStatement": "كشف حساب موظف",
 "employeesSalaries": "رواتب الموظفين",
 "partiesReport": "تقرير العملاء والموردين",
 "treasuryReport": "تقرير الخزائن",
 "treasuryStatement": "كشف حساب خزينة",
 "movementSummary": "ملخص الحركة",
 "salesTax": "ضريبة المبيعات",
 "purchaseTax": "ضريبة المشتريات",
 "assetTax": "تقرير ضريبة الأصول",
 "taxReturn": "الإقرار الضريبي",
 "assetsReport": "تقرير الأصول",
 "assetDepReport": "تقرير إهلاك الأصول",
 "assetInvoicesR": "فواتير الأصول",
 "assetInvoiceDetails": "تفاصيل فواتير الأصول",
 "warehousesReport": "تقرير المخازن",
 "movement": "الحركة",
 "netMovement": "صافي الحركة",
 "endBalance": "الرصيد الختامي",
 "percentagePct": "النسبة (%)",
 "cost": "التكلفة",
 "profit": "الربح",
 "salary": "الراتب",
 "rpIn": "وارد",
 "rpOut": "صادر",
 "drS": "مدين",
 "crS": "دائن",
 "depreciationDate": "تاريخ الإهلاك",
 "excelExport": "تصدير إكسل",
 "chooseDots": "اختر…",
 "netProfit": "صافي الربح (الخسارة)",
 "periodProfit": "أرباح الفترة (محسوبة)",
 "totalAssets": "إجمالي الأصول",
 "totalLiabEq": "إجمالي الخصوم وحقوق الملكية",
 "notBalanced": "غير متوازن",
 "bsBalanced": "الأصول تساوي الخصوم مع حقوق الملكية لهذه الفترة.",
 "bsNotBalanced": "الأصول لا تساوي الخصوم مع حقوق الملكية. راجع القيود.",
 "taxDue": "ضريبة مستحقة",
 "totalRevenues": "إجمالي الإيرادات",
 "totalExpenses": "إجمالي المصروفات",
 "taxRefundable": "ضريبة مستردة",
 "pr_today": "اليوم",
 "pr_yesterday": "أمس",
 "pr_thisWeek": "هذا الأسبوع",
 "pr_lastWeek": "الأسبوع الماضي",
 "pr_thisMonth": "هذا الشهر",
 "pr_lastMonth": "الشهر الماضي",
 "pr_thisYear": "هذه السنة",
 "pr_lastYear": "السنة الماضية",
 "prQ": "الربع {n}",
 "pr_all": "كل التواريخ",
 "pr_custom": "فترة مخصصة",
 "rpFiltersChanged": "تغيرت عوامل التصفية. اضغط بحث لتحديث النتائج.",
 "rpChoose": "اختر {x} ثم اضغط بحث.",
 "rpResults": "النتائج",
 "rpHubSearch": "ابحث عن تقرير",
 "rpHubSub": "{n} رابط تقرير في {g} مجموعات. كل التقارير تقرأ نفس القيود التجريبية المستخدمة في باقي الشاشات.",
 "rpNoMatch": "لا يوجد تقرير مطابق لبحثك",
 "rpMenuOnly": "في القائمة فقط في النظام الحالي",
 "rpMovedNote": "يظهر هذا التقرير في النظام الحالي في القائمة الجانبية فقط، وتعرضه دلتا الجديدة في صفحة التقارير أيضاً.",
 "rpSearchWordPh": "الاسم أو الرمز أو الباركود",
 "rpXlsToast": "تم تصدير {n} صفاً إلى {f}. يُنشأ الملف في هذا المتصفح.",
 "planIncludesLong": "{u} مستخدمين و{w} مخازن، فوترة {p}.",
 "next": "التالي",
 "cartSimHint": "الأسعار تجريبية.",
 "planCart": "سلة الخطط",
 "accessDenied": "لا توجد صلاحية",
 "accessDeniedTitle": "ليست لديك صلاحية لفتح هذه الصفحة",
 "accessDeniedBody": "المستخدم التجريبي {u} لا يملك الصلاحية التالية.",
 "accessDeniedHint": "يمكن للمسؤول منحها من الإعدادات › المستخدمين › تعديل الصلاحية. في هذا النموذج يتم التحقق داخل المتصفح فقط، ويجب أن يفرضه النظام الفعلي على الخادم.",
 "switchDemoUser": "تبديل المستخدم التجريبي",
 "roleAdmin": "مدير النظام",
 "roleRestricted": "مستخدم مقيد",
 "switchedTo": "تم الدخول باسم {x}.",
 "noPermission": "بدون صلاحية",
 "noPermissionFor": "بدون صلاحية: {p}",
 "anyReport": "أي تقرير",
 "demoUserNow": "نطاق المستخدم التجريبي",
 "scopeAll": "كل الفروع والمخازن والخزائن",
 "scopeOf": "الفرع: {b} · المخازن: {w} · الخزائن: {tr}",
 "scopeDenied": "هذا المستخدم لا يملك صلاحية على هذا المخزن أو الخزينة.",
 "noTreasuryScope": "لا توجد خزينة مخصصة لهذا المستخدم."
};
